<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2 " style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);">
            <i class="fa fa-newspaper-o text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Venda Pré-Fatura</h4>
            <small class="text-muted small">Listagem e Gestão de Pedidos</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end">
            <!-- Charts Section -->
            <div class="d-none d-xl-flex align-items-center mr-3">
                <div class="callout mr-3 border-0 bg-transparent py-0 text-center" @click="abrirModalGraficosVendedores" style="cursor: pointer">
                    <small class="text-muted d-block mb-0 font-weight-bold" style="font-size: 0.7rem;">Vendedores</small>
                    <div class="cec-chart-box justify-content-center">
                        <grafico-barra-vendedores-pequeno
                            :data="graficos.vendedores.datasets"
                            :labels="graficos.vendedores.labels"
                            :height="30"
                        />
                    </div>
                </div>
                <div class="callout border-0 bg-transparent py-0 mt-3 text-center" @click="abrirModalGraficosMovimento" style="cursor: pointer">
                    <small class="text-muted d-block mb-0 font-weight-bold" style="font-size: 0.7rem;">Movimento</small>
                    <div class="cec-chart-box justify-content-center">
                        <grafico-linha-vendas-pequeno
                            :points="graficos.vendasPointsPequeno"
                            :dt1="dt1" :dt2="dt2"
                            :height="30"
                        />
                    </div>
                </div>
            </div>

            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-code-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2 date-inputs-responsive">
                    <cec-input-data ref="dt1" v-model="dt1" class="mx-1"  style="width: 145px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1 d-none d-sm-inline">até</span>
                    <cec-input-data v-model="dt2" class="mx-1"  style="width: 145px" @keydown.enter.native="pesquisar()" />
                    <b-form-input
                      type="text"
                      v-model="id"
                      placeholder="N. Controle"
                      class="rounded-pill shadow-xs mx-1"
                      style="width: 135px"
                      @keydown.enter.native="pesquisar()"
                    />
                </div>

                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
                </b-button>
            </div>

            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click="novo()">
                <i class="fa fa-plus-circle mr-1"></i> <span class="d-none d-sm-inline">Adicionar</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="modal-label-premium">Nº Pedido</label>
                      <b-form-input type="text" v-model="pedido" placeholder="Ex: 12345" class="rounded-pill shadow-xs" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <label class="modal-label-premium">Situação da Venda</label>
                      <b-form-select v-model="tipoSituacao" :options="optionsSituacao" class="rounded-pill shadow-xs" @keydown.enter.native="pesquisar()"></b-form-select>
                    </b-col>
                    <b-col md="7">
                      <cliente-pesquisa 
                        @retornaId="clienteId = $event"
                        :idInicial="clienteId"
                        label="Cliente"
                        place="Busque por nome ou código..."
                        labelBotao=""
                        ref="clientepesquisa"
                        idModal="clientepesquisa"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                  </b-row>
                  <b-row align-v="end" class="mt-3">
                    <b-col md="3">
                      <label class="modal-label-premium">NFe</label>
                      <b-form-input
                        v-model="nfeRelacionada"
                        placeholder="Número ou ID da NFe"
                        class="rounded-pill shadow-xs"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                    <b-col md="3">
                      <label class="modal-label-premium">Forma Pagto.</label>
                      <b-form-select
                        v-model="filtroFormaPagto"
                        :options="optionsFiltroFormaPagto"
                        class="rounded-pill shadow-xs"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                    <b-col md="3">
                      <label class="modal-label-premium">Boleto</label>
                      <b-form-select
                        v-model="filtroBoleto"
                        :options="optionsFiltroBoleto"
                        class="rounded-pill shadow-xs"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                    <b-col md="3">
                      <label class="modal-label-premium">NF</label>
                      <b-form-select
                        v-model="filtroNf"
                        :options="optionsFiltroNf"
                        class="rounded-pill shadow-xs"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                  </b-row>
                  <b-row align-v="end" class="mt-3">
                    <b-col md="3">
                      <label class="modal-label-premium">Financeiro</label>
                      <b-form-select
                        v-model="filtroFinanceiro"
                        :options="optionsFiltroFinanceiro"
                        class="rounded-pill shadow-xs"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                    <b-col md="3">
                      <label class="modal-label-premium">Origem</label>
                      <b-form-select
                        v-model="filtroOrigem"
                        :options="optionsFiltroOrigem"
                        class="rounded-pill shadow-xs"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                    <b-col md="3">
                      <label class="modal-label-premium">Alterado</label>
                      <b-form-select
                        v-model="filtroAlterado"
                        :options="optionsFiltroAlterado"
                        class="rounded-pill shadow-xs"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                    <b-col md="3">
                      <label class="modal-label-premium">Entrega</label>
                      <b-form-select
                        v-model="filtroEntrega"
                        :options="optionsFiltroEntrega"
                        class="rounded-pill shadow-xs"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <!-- Main table element -->
            <b-table 
                  class="mb-0 table-finance"
                  id="table-transition-example"
                  ref="tbl"
                  show-empty
                  empty-text="Informe o filtro para ver os registros "
                  :dark="isDark"
                  small 
                  responsive
                  :tbody-tr-class="rowClassSelecionado"
                  hover
                  :sticky-header="stickyHeight"
                  @row-clicked="clicarLinha"
                  @row-dblclicked="edit"
                  :items="itensFiltrados"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage">

               <!-- Ícone de ação: seta -->
              <template #cell(DETALHE)="row">
                <i 
                  :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                    @click.stop="toggleDetalhesVenda(row)"
                  style="cursor: pointer"
                ></i>
              </template>
              <!-- Detalhes -->
              <template #row-details="row">
                <div v-if="row.item.loading">
                  Carregando detalhes...
                </div>
                <div v-else>
                  <b-table 
                    head-variant="dark"
                    hover="false"
                    :table-variant="isDark ? 'primary' : 'light'"
                    :items="row.item.detalhes" 
                    :fields="tabelaItens.fields">
                  </b-table>
                </div>
              </template>
              <template #head(NOME_CLIENTE)>
                <SetFilter
                  label="Cliente "
                  v-model="filtros.NOME_CLIENTE"
                  :options="opcoes.NOME_CLIENTE"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>  
              <template #head(N_VENDA)>
                <SetFilter
                  label="Pedido "
                  v-model="filtros.N_VENDA"
                  :options="opcoes.N_VENDA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'gray-200'"
                />
              </template>  
              <template #head(SITUACAO)>
                <SetFilter
                  label="Situação "
                  v-model="filtros.SITUACAO"
                  :options="opcoes.SITUACAO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'gray-200'"
                />
              </template>  
              <template #head(DT_SAIDA)>
                <SetFilter
                  label="Data"
                  v-model="filtros.DT_SAIDA"
                  :options="opcoes.DT_SAIDA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'gray-200'"
                />
              </template>  
              <template #head(NOME_VENDEDOR)>
                <SetFilter
                  label="Vendedor"
                  v-model="filtros.NOME_VENDEDOR"
                  :options="opcoes.NOME_VENDEDOR"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'gray-200'"
                />
              </template>  
              <template #head(FORMA)>
                <SetFilter
                  label="Forma"
                  v-model="filtros.FORMA"
                  :options="opcoes.FORMA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'gray-200'"
                />
              </template>  
              <template #head(VL_TOTAL_NFE)>
                <SetFilter
                  label="Total R$"
                  v-model="filtros.VL_TOTAL_NFE"
                  :options="opcoes.VL_TOTAL_NFE"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'gray-200'"
                />
              </template>  

              <template #cell(SITUACAO)="item">
                <b-badge pill class="px-3 py-1 shadow-xs" :variant="colorirStatus(item.item.SITUACAO, item.item)">
                    {{traduzirSituacao(item.item)}}
                </b-badge>
              </template>      
              <template #cell(OP_FORMA_PAGTO)="item">
                <div class="d-flex flex-wrap gap-1">
                    <b-badge pill class="shadow-xs mb-1" :variant="colorirOP_FORMA_PAGTO(item.item.OP_FORMA_PAGTO)">{{traduzirOP_FORMA_PAGTO(item.item.OP_FORMA_PAGTO)}}</b-badge>
                    <b-badge pill class="shadow-xs mb-1" :variant="colorirBoleto(item.item.OP_STATUS_BOLETO_EMITIDO)">{{traduzirBoleto(item.item.OP_STATUS_BOLETO_EMITIDO)}}</b-badge>
                    <b-badge pill class="shadow-xs mb-1" :variant="colorirNF(item.item)">{{traduzirNF(item.item)}}</b-badge>
                    <b-badge pill class="shadow-xs mb-1" :variant="colorirFinanceiro(item.item.TEM_FINANCEIRO)">{{traduzirFinanceiro(item.item.TEM_FINANCEIRO)}}</b-badge>
                    <b-badge pill class="shadow-xs mb-1" :variant="colorirOrigem(item.item.OP_PEDIDO)">{{traduzirOrigem(item.item.OP_PEDIDO)}}</b-badge>
                    <b-badge pill class="shadow-xs mb-1" :variant="colorirAlterado(item.item.OP_ALTERADO)">{{traduzirAlterado(item.item.OP_ALTERADO)}}</b-badge>
                    <b-badge v-if="item.item.OP_RETORNO_ENTREGA === '1'" pill class="shadow-xs mb-1" variant="success">
                      <i class="fa fa-check-circle mr-1"></i>ENTREGUE
                    </b-badge>
                </div>
              </template>  

              <template #cell(NOME_CLIENTE)="item">
                 <div class="font-weight-bold text-dark">{{ item.item.NOME_CLIENTE }}</div>
                 <small class="text-muted">Cód: {{ item.item.COD_CLI }}</small>
              </template>  
              <template #cell(NFE_RELACIONADA)="item">
                <span class="font-weight-bold">{{ item.item.NFE_RELACIONADA || '-' }}</span>
              </template>
              <template #cell(actions)="item">
                <div class="d-flex align-items-center gap-1">
                  <b-dropdown
                      right
                      dropup 
                      boundary="viewport"
                      :popper-opts="{ positionFixed: true }"
                      no-caret
                      variant="link"
                      toggle-class="p-1 text-muted no-decoration"
                      class="mr-1"
                  > 
                    <template #button-content>
                      <b-button variant="soft-primary" pill class="btn-icon-only shadow-sm">
                        <i class="fa fa-ellipsis-v"></i>
                      </b-button>
                    </template>

                    <b-dropdown-item
                      v-if="podeVisualizarBoleto(item.item)"
                      @click="visualizarBoleto(item.item)">
                      <i class="fa fa-eye mr-2 text-info"></i>Visualizar Boleto
                    </b-dropdown-item>
                    <b-dropdown-item
                        :disabled="!podeGerarBoleto(item.item)"
                        @click="abrirModalGerarBoleto(item.item)">
                        <i class="fa fa-barcode mr-2 text-primary"></i>Gerar Boleto
                    </b-dropdown-item>
                    <b-dropdown-item  v-if="nfeAutorizada(item.item)"
                      @click="downloadPDFNfe(item.item)">
                      <i class="fa fa-file-pdf-o mr-2 text-danger"></i>Visualizar Nota Fiscal
                    </b-dropdown-item>
                    <b-dropdown-item   v-else-if="podeGerarNotaFiscal(item.item)"
                      @click="abrirModalNotaFiscal(item.item)" >
                      <i class="fa fa-file-pdf-o mr-2 text-primary"></i>Gerar Nota Fiscal
                    </b-dropdown-item>
                    
                    <b-dropdown-divider></b-dropdown-divider>
                    
                    <b-dropdown-item  :disabled="(!['6'].includes(item.item.SITUACAO))"
                       @click="showMsgDevolver(item.item)"  >
                      <i class="fa fa-reply mr-2 text-warning"></i>Devolver para o Terminal
                    </b-dropdown-item>
                    
                    <b-dropdown-item
                      :disabled="!podeConfirmarEntrega(item.item)"
                      @click="confirmarEntregaVenda(item.item)">
                      <i class="fa fa-check mr-2 text-success"></i>Confirmar Entrega
                    </b-dropdown-item>

                    <b-dropdown-item @click="abrirOcorrenciasVenda(item.item)">
                      <i class="fa fa-comments mr-2 text-info"></i>Ver Ocorrências
                    </b-dropdown-item>

                    <b-dropdown-item @click="abrirDocumentosVenda(item.item)">
                      <i class="fa fa-paperclip mr-2 text-warning"></i>Ver Canhotos/Docs
                    </b-dropdown-item>
                    
                    <b-dropdown-item @click="abrirModalRemoverEtiquetas(item.item)">
                      <i class="fa fa-eraser mr-2 text-danger"></i>Remover Etiquetas
                    </b-dropdown-item>
                    
                    <b-dropdown-divider></b-dropdown-divider>
                    
                    <b-dropdown-item v-if="['1', '6'].includes(item.item.SITUACAO)" @click.stop.prevent="imprimirPesagemExpedicao(item.item.SEQUENCIA)">
                      <i class="fa fa-balance-scale mr-2 text-primary"></i>Imprimir Pesagem Expedição
                    </b-dropdown-item>

                    <b-dropdown-item @click="abrirModalInfo(item.item)">
                      <i class="fa fa-info-circle mr-2 text-info"></i>Exibir Detalhes
                    </b-dropdown-item>
                  </b-dropdown>
                
                  <b-button :disabled="(['2'].includes(item.item.SITUACAO))" variant="soft-primary" pill class="btn-icon-only shadow-sm" @click.stop.prevent="imprimir(item.item.SEQUENCIA)" v-b-tooltip.hover title="Re-imprimir">
                    <i class="fa fa-print"></i>
                  </b-button>
                  
                  <b-button :disabled="(!['2','3'].includes(item.item.SITUACAO))" variant="soft-danger" pill class="btn-icon-only shadow-sm" @click="abrirModalCancelamento(item.item)" v-b-tooltip.hover title="Cancelar Venda">
                    <i class="fa fa-times"></i>
                  </b-button>
                </div>
              </template>
              <!-- Alternativamente, usando custom-foot para linha de rodapé completa -->
              <template #custom-foot="{ fields, items }">
                <b-tr>
                  <b-td></b-td>
                  <b-td class="text-right font-weight-bold" v-for="(field, idx) in fields.slice(1)" :key="idx">
                    <!-- supondo que "campoValor" seja a key da coluna cujo total você quer -->
                    <span class="text-right font-weight-bold" v-if="field.key === 'N_VENDA'">Itens: ({{ itensFiltrados.length }})</span>
                    <span class="text-right font-weight-bold" v-if="field.key === 'VL_TOTAL_NFE'">{{ vlTotalNfeRodape }}</span>
                  </b-td>
                </b-tr>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL REMOVER ETIQUETAS 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-remover-etiquetas" 
          id="modal-remover-etiquetas" 
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          size="xl"
          @shown="focusModalCancelamento()" 
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #e53e3e 0%, #7d1c1c 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-eraser text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Remover Etiquetas da Expedição</h5>
                <small class="text-white opacity-75">Gestão de rastreabilidade física do pedido</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-remover-etiquetas')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <!-- Modal Info Bar -->
            <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                <b-row align-v="center">
                    <b-col md="6">
                        <small class="modal-label-premium">Cliente</small>
                        <h5 class="mb-0 font-weight-bold text-dark">{{removerEtiquetas.dados.nomeCliente}}</h5>
                    </b-col>
                    <b-col md="3" class="border-left">
                        <small class="modal-label-premium">Pedido / Parcela</small>
                        <h5 class="mb-0 font-weight-bold text-primary">{{removerEtiquetas.dados.documento}} - {{removerEtiquetas.dados.parcela}}</h5>
                    </b-col>
                    <b-col md="3" class="border-left text-right">
                        <small class="modal-label-premium">Valor Total</small>
                        <h5 class="mb-0 font-weight-bold text-success">{{removerEtiquetas.dados.valorDocumento}}</h5>
                    </b-col>
                </b-row>
            </div>

            <div class="modal-section-title mb-3">
                <i class="fa fa-tags mr-2 text-danger"></i> Etiquetas Lançadas na Expedição
            </div>

            <div class="bg-white rounded border shadow-xs overflow-hidden mb-4">
              <b-table 
                    hover 
                    show-empty
                    empty-text="Nenhuma etiqueta lançada na expedição"
                    small
                    responsive 
                    class="mb-0 table-finance"
                    :items="removerEtiquetas.itensEtiquetas" 
                    :fields="removerEtiquetas.fieldsEtiquetas"
                    per-page="10"
                    :current-page="removerEtiquetas.parametros.currentPage"
              >
                    <template #cell(actions)="item">
                      <b-button variant="soft-danger" pill size="sm" class="btn-icon-only shadow-sm" @click="removerEtiquetaExpedicao(item.item)" title="Remover Etiqueta">
                        <i class="fa fa-times"></i>
                      </b-button>
                    </template>
              </b-table>
              <div class="p-2 border-top bg-light d-flex justify-content-center">
                  <b-pagination size="sm" :total-rows="removerEtiquetas.itensEtiquetas.length" per-page="10" v-model="removerEtiquetas.parametros.currentPage" class="mb-0 py-1" />
              </div>
            </div>

            <div class="modal-section-title mb-3">
                <i class="fa fa-list mr-2 text-primary"></i> Resumo de Produtos do Pedido
            </div>

            <div class="bg-white rounded border shadow-xs overflow-hidden">
              <b-table 
                    hover 
                    show-empty
                    empty-text="Venda sem produtos lançados"
                    small
                    responsive 
                    class="mb-0 table-finance"
                    :items="removerEtiquetas.itensVenda" 
                    :fields="removerEtiquetas.fieldsVenda"
              />
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top text-right">
            <b-button variant="soft-danger" pill class="px-5 font-weight-bold shadow-sm" @click="$bvModal.hide('modal-remover-etiquetas')">
                FECHAR GESTOR
            </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL CANCELAMENTO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-cancelamento" 
          id="modal-cancelamento" 
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          size="lg"
          @shown="focusModalCancelamento()" 
      >
        <b-overlay :show="cancelamento.parametros.overlayBaixando" no-wrap fixed z-index="1100" spinner-variant="danger" spinner-type="border">
          <template #overlay>
            <div class="text-center bg-white p-4 rounded shadow-lg border">
              <b-icon icon="slash-circle" font-scale="3" class="text-danger mb-3" animation="pulse"></b-icon>
              <h5 class="font-weight-bold">Cancelando Pedido...</h5>
              <p class="text-muted mb-0">Esta ação pode levar alguns segundos.</p>
            </div>
          </template>
        </b-overlay>

        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #1f2937 0%, #000000 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-close text-danger"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Cancelar Venda Pré-Fatura</h5>
                <small class="text-white opacity-75">Anulação irreversível de documento de venda</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-cancelamento')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 bg-soft-danger border border-danger shadow-sm p-3 rounded">
                <b-row align-v="center">
                    <b-col md="6">
                        <small class="modal-label-premium">Cliente</small>
                        <h5 class="mb-0 font-weight-bold text-dark">{{cancelamento.dados.nomeCliente}}</h5>
                    </b-col>
                    <b-col md="3" class="border-left border-danger-soft">
                        <small class="modal-label-premium">Pedido / Parcela</small>
                        <h5 class="mb-0 font-weight-bold text-danger">{{cancelamento.dados.documento}} - {{cancelamento.dados.parcela}}</h5>
                    </b-col>
                    <b-col md="3" class="border-left border-danger-soft text-right">
                        <small class="modal-label-premium">Valor Pedido</small>
                        <h5 class="mb-0 font-weight-bold text-danger">{{cancelamento.dados.valorDocumento}}</h5>
                    </b-col>
                </b-row>
            </div>

            <div v-if="cancelamento.parametros.permissao === false" class="alert bg-soft-danger border-danger text-danger text-center p-4 rounded-lg shadow-xs mt-3">
                <i class="fa fa-lock fa-3x mb-3"></i>
                <h4 class="font-weight-bold mb-1">ACESSO NEGADO</h4>
                <p class="mb-0">Você não possui permissões suficientes para realizar o cancelamento desta venda.</p>
            </div>

            <template v-else>
                <div class="modal-section-title mb-3">
                    <i class="fa fa-commenting mr-2 text-danger"></i> Justificativa do Cancelamento
                </div>
                <div class="p-3 bg-light rounded border mb-3 shadow-xs">
                     <label class="modal-label-premium">Motivo do Cancelamento <span class="text-danger">*</span></label>
                     <b-form-textarea 
                        ref="motivoCancelamento" 
                        id="motivoCancelamento" 
                        v-model="cancelamento.dados.motivo" 
                        :state="valMotivoCancelamento"
                        placeholder="Informe detalhadamente o porquê desta venda estar sendo cancelada..."
                        rows="4"
                        class="shadow-xs border-0"
                     ></b-form-textarea>
                     <small class="text-muted mt-2 d-block"><i class="fa fa-info-circle mr-1"></i> Esta informação será registrada na trilha de auditoria do sistema.</small>
                </div>
            </template>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
            <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-cancelamento')">
                VOLTAR
            </b-button>
            <b-button v-if="cancelamento.parametros.permissao === true" variant="danger" pill class="px-5 font-weight-bold shadow-sm" @click="cancelar()">
                <i class="fa fa-check-circle mr-1"></i> CONFIRMAR CANCELAMENTO
            </b-button>
        </div>
      </b-modal>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                            MODAL INFO 
      ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-info" 
          id="modal-info" 
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          size="xl"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-info-circle text-info"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Detalhamento da Venda</h5>
                <small class="text-white opacity-75">Resumo completo e histórico de transação</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-info')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                <b-row align-v="center">
                    <b-col md="6">
                        <small class="modal-label-premium">Cliente / Vendedor</small>
                        <h5 class="mb-0 font-weight-bold text-dark">{{dadosModalInfo.nomeCliente}}</h5>
                        <small class="text-muted font-weight-bold">Atendido por: {{dadosModalInfo.nomeVendedor}}</small>
                    </b-col>
                    <b-col md="3" class="border-left">
                        <small class="modal-label-premium">Documento / Data</small>
                        <h5 class="mb-0 font-weight-bold text-primary">{{dadosModalInfo.documento}}</h5>
                        <small class="text-muted font-weight-bold">{{dadosModalInfo.dataVenda}}</small>
                    </b-col>
                    <b-col md="3" class="border-left text-right">
                        <small class="modal-label-premium">Total da Venda</small>
                        <h5 class="mb-0 font-weight-bold text-success" style="font-size: 1.5rem;">{{dadosModalInfo.total}}</h5>
                    </b-col>
                </b-row>
            </div>

            <b-row>
                <b-col md="6">
                    <div class="modal-section-title mb-3">
                        <i class="fa fa-edit mr-2 text-warning"></i> Histórico de Alteração
                    </div>
                    <div class="p-3 bg-light rounded border shadow-xs mb-4">
                        <b-row class="mb-2">
                            <b-col sm="6">
                                <small class="modal-label-premium">Data da Alteração</small>
                                <span class="font-weight-bold">{{dadosModalInfo.dataAlteracao || '-'}}</span>
                            </b-col>
                            <b-col sm="6">
                                <small class="modal-label-premium">Responsável</small>
                                <span class="font-weight-bold">{{dadosModalInfo.usuarioAlteracao || '-'}}</span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <small class="modal-label-premium">Motivo Registrado</small>
                                <p class="mb-0 italic text-muted">{{dadosModalInfo.motivoAlteracao || 'Nenhuma alteração registrada.'}}</p>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
                <b-col md="6">
                    <div class="modal-section-title mb-3">
                        <i class="fa fa-ban mr-2 text-danger"></i> Registro de Cancelamento
                    </div>
                    <div class="p-3 bg-light rounded border shadow-xs mb-4">
                        <b-row class="mb-2">
                            <b-col sm="6">
                                <small class="modal-label-premium">Data do Cancelamento</small>
                                <span class="font-weight-bold">{{dadosModalInfo.dataCancelamento || '-'}}</span>
                            </b-col>
                            <b-col sm="6">
                                <small class="modal-label-premium">Responsável</small>
                                <span class="font-weight-bold">{{dadosModalInfo.usuarioCancelamento || '-'}}</span>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <small class="modal-label-premium">Motivo do Cancelamento</small>
                                <p class="mb-0 italic text-muted">{{dadosModalInfo.motivoCancelamento || 'Venda ativa/não cancelada.'}}</p>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>

            <div class="modal-section-title mb-3">
                <i class="fa fa-cubes mr-2 text-primary"></i> Itens do Pedido
            </div>
            <div class="bg-white rounded border shadow-xs overflow-hidden">
                <b-table 
                    hover 
                    show-empty
                    empty-text="Venda sem produtos lançados"
                    small
                    responsive 
                    class="mb-0 table-finance"
                    :items="tabelaItens.items" 
                    :fields="tabelaItens.fields"
                />
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top text-right">
            <b-button variant="soft-danger" pill class="px-5 font-weight-bold shadow-sm" @click="$bvModal.hide('modal-info')">
                FECHAR DETALHES
            </b-button>
        </div>
      </b-modal>
    </div>
     <!--  -----------------------------------------------------------------------------------
                                            MODAL NOTA FISCAL
      ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-nota-fiscal" 
          id="modal-nota-fiscal" 
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          size="xl"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #20a8d8 0%, #000000 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-file-text-o text-primary"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Emissão de Nota Fiscal Eletrônica</h5>
                <small class="text-white opacity-75">Configuração e transmissão de documentos fiscais</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-nota-fiscal')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                <b-row align-v="center">
                    <b-col md="6">
                        <small class="modal-label-premium">Cliente Destinatário</small>
                        <h5 class="mb-0 font-weight-bold text-dark">{{dadosModalNotaFiscal.nomeCliente}}</h5>
                    </b-col>
                    <b-col md="3" class="border-left">
                        <small class="modal-label-premium">Documento Base</small>
                        <h5 class="mb-0 font-weight-bold text-primary">{{dadosModalNotaFiscal.documento}}</h5>
                    </b-col>
                    <b-col md="3" class="border-left text-right">
                        <small class="modal-label-premium">Valor da Nota</small>
                        <h5 class="mb-0 font-weight-bold text-success">{{dadosModalNotaFiscal.total}}</h5>
                    </b-col>
                </b-row>
            </div>

            <div class="modal-section-title mb-3">
                <i class="fa fa-cogs mr-2 text-primary"></i> Parâmetros Fiscais de Emissão
            </div>
            
            <div class="p-4 bg-light rounded border shadow-xs mb-4">
                <b-row class="mb-3">
                    <b-col :md="nfeMotorNodeAtivo ? 8 : 12">
                        <label class="modal-label-premium">Empresa Emitente</label>
                        <b-form-select 
                            v-model="dadosModalNotaFiscal.empresaId"
                            :options="empresas.options" 
                            :state="valEmpresaId"
                            class="rounded-pill shadow-xs"
                        />
                    </b-col>
                    <b-col v-if="nfeMotorNodeAtivo" md="4">
                        <label class="modal-label-premium">Tipo de Atendimento</label>
                        <b-form-select
                            v-model="dadosModalNotaFiscal.opTipoAtendimento"
                            :options="opTipoAtendimentoNfeOptions"
                            :state="valTipoAtendimentoNfe"
                            class="rounded-pill shadow-xs"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col md="2">
                        <label class="modal-label-premium">Data Saí/Ent</label>
                        <CecInputData
                            v-model="dadosModalNotaFiscal.DT_SADIA_ENTRADA"
                            input-class="rounded-pill shadow-xs"
                        />
                    </b-col>
                    <b-col md="2">
                        <label class="modal-label-premium">Hora Saí/Ent</label>
                        <b-form-timepicker
                            v-model="dadosModalNotaFiscal.TX_HORA_ENTRA_SAI"
                            locale="pt-BR"
                            placeholder="00:00:00"
                            show-seconds
                            class="rounded-pill shadow-xs"
                        />
                    </b-col>
                    <b-col v-if="nfeMotorNodeAtivo" md="8">
                        <label class="modal-label-premium">Tipo de Movimentação</label>
                        <b-form-select
                            v-model="dadosModalNotaFiscal.tipoMovimentacaoId"
                            :options="dadosModalNotaFiscal.tipoMovimentacoes.options"
                            :state="valTipoMovimentacaoId"
                            class="rounded-pill shadow-xs"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <label class="modal-label-premium">Informações Complementares (Contribuinte)</label>
                        <b-form-textarea
                            v-model="dadosModalNotaFiscal.obsContribuinte"
                            placeholder="Informações que sairão no corpo da nota..."
                            rows="3"
                            class="rounded shadow-xs border-0"
                        />
                    </b-col>
                </b-row>
            </div>

            <b-alert
                v-if="cfopDiagnosticoNotaFiscal"
                :variant="cfopDiagnosticoNotaFiscal.variant"
                show
                class="mb-4 rounded"
            >
                <strong>CFOP {{ cfopDiagnosticoNotaFiscal.id }}</strong> - {{ cfopDiagnosticoNotaFiscal.mensagem }}
            </b-alert>

            <b-alert
                v-if="preflightPendenciasNotaFiscal.length"
                :variant="preflightTemErroNotaFiscal ? 'danger' : 'warning'"
                show
                class="mb-4 rounded"
            >
                <div class="font-weight-bold mb-2">
                    Validação fiscal da NF-e
                    <span v-if="dadosModalNotaFiscal.nfeId" class="ml-2 text-muted">#{{ dadosModalNotaFiscal.nfeId }}</span>
                </div>
                <ul class="mb-0 pl-3">
                    <li v-for="(pendencia, index) in preflightPendenciasNotaFiscal" :key="index">
                        <strong>{{ pendencia.codigo }}</strong> - {{ pendencia.mensagem }}
                    </li>
                </ul>
            </b-alert>

            <div class="modal-section-title mb-3">
                <i class="fa fa-list-alt mr-2 text-primary"></i> Conferência de Itens
            </div>
            <div class="bg-white rounded border shadow-xs overflow-hidden">
                <b-table 
                    hover 
                    show-empty
                    empty-text="Nenhum item para faturar"
                    small
                    responsive 
                    class="mb-0 table-finance"
                    :items="tabelaItens.items" 
                    :fields="tabelaItens.fields"
                />
            </div>

            <b-alert
                v-if="dadosModalNotaFiscal.mensagem.texto"
                :variant="dadosModalNotaFiscal.mensagem.tipo"
                show
                class="mt-3 mb-0 rounded"
            >
                <i class="fa mr-2" :class="dadosModalNotaFiscal.mensagem.tipo === 'danger' ? 'fa-times-circle' : (dadosModalNotaFiscal.mensagem.tipo === 'success' ? 'fa-check-circle' : 'fa-exclamation-triangle')"></i>
                {{ dadosModalNotaFiscal.mensagem.texto }}
            </b-alert>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
            <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-nota-fiscal')">
                CANCELAR
            </b-button>
            <div class="d-flex flex-wrap justify-content-end">
                <b-button
                    v-if="nfeMotorNodeAtivo"
                    variant="outline-primary"
                    pill
                    class="px-4 mr-2 font-weight-bold shadow-sm"
                    @click="validarNotaFiscalMotorNode()"
                    :disabled="!valEmitirNotaFiscal"
                >
                    <i class="fa fa-check-circle mr-1"></i> VALIDAR NFE
                </b-button>
                <b-button variant="primary" pill class="px-5 font-weight-bold shadow-sm" @click="emitirNotaFiscal()" :disabled="!valEmitirNotaFiscal">
                    <i class="fa fa-send mr-1"></i> TRANSMITIR NFE
                </b-button>
            </div>
        </div>
      </b-modal>
    </div>
    <div>
        <!--  -----------------------------------------------------------------------------------
                                            MODAL GERAR BOLETO 
          ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-boleto-gerar" 
          id="modal-boleto-gerar" 
          hide-header
          hide-footer
          body-class="p-0 overflow-hidden"
          content-class="border-0 shadow-lg"
          size="lg"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-barcode text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Gerar Título Bancário (Boleto)</h5>
                <small class="text-white opacity-75">Configuração de conta e emissão de cobrança</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-boleto-gerar')">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                <b-row align-v="center">
                    <b-col md="8">
                        <small class="modal-label-premium">Cliente Pagador</small>
                        <h5 class="mb-0 font-weight-bold text-dark">{{ boleto.clienteId }} - {{ boleto.nomeCliente }}</h5>
                        <small class="text-muted font-weight-bold">Título: {{ boleto.documento }} / {{ boleto.parcela }}</small>
                    </b-col>
                    <b-col md="3" class="border-left text-right">
                        <small class="modal-label-premium text-right">Valor Total</small>
                        <h5 class="mb-0 font-weight-bold text-success">{{formatCurrency(boleto.valorDocumento)}}</h5>
                    </b-col>
                </b-row>
            </div>

            <div class="modal-section-title mb-3">
                <i class="fa fa-university mr-2 text-primary"></i> Configurações de Recebimento
            </div>
            
            <div class="p-4 bg-light rounded border shadow-xs mb-4">
                <b-row class="mb-3">
                    <b-col md="12">
                        <label class="modal-label-premium">Empresa Emitente</label>
                        <b-form-select 
                            v-model="boleto.empresaId"
                            :options="empresas.options" 
                            :state="!!boleto.empresaId"
                            class="rounded-pill shadow-xs"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <label class="modal-label-premium">Conta para Depósito / Cobrança</label>
                        <b-form-select   
                                  v-model="boleto.contaId" 
                                  :options="contasOpcoes" 
                            :state="!!boleto.contaId"
                                  ref="comboconta"
                                  class="rounded-pill shadow-xs"
                        >
                            <template slot="first">
                              <option :value="null">-- Selecione a conta bancária --</option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
            </div>

            <div class="modal-section-title mb-3">
                <i class="fa fa-money mr-2 text-primary"></i> Resumo de Saldos
            </div>
            
            <b-row>
                <b-col md="4">
                    <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                        <small class="modal-label-premium">Vlr. Original</small>
                        <h5 class="mb-0 font-weight-bold text-dark">{{formatCurrency(boleto.valorDocumento)}}</h5>
                    </div>
                </b-col>
                <b-col md="4">
                    <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                        <small class="modal-label-premium">Recebimentos</small>
                        <h5 class="mb-0 font-weight-bold text-info">{{formatCurrency(boleto.valorRecebimentos)}}</h5>
                    </div>
                </b-col>
                <b-col md="4">
                    <div class="p-3 bg-white rounded border shadow-sm text-center h-100 border-success border-2">
                        <small class="modal-label-premium text-success">Vlr. à Gerar</small>
                        <h4 class="mb-0 font-weight-bold text-success">{{formatCurrency(boleto.valorRestante)}}</h4>
                    </div>
                </b-col>
            </b-row>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
            <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-boleto-gerar')">
                CANCELAR
            </b-button>
          <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="gerarBoleto()" :disabled="!podeConfirmarGeracaoBoleto">
                <i class="fa fa-barcode mr-1"></i> GERAR BOLETO AGORA
            </b-button>
        </div>
      </b-modal>
    </div>

    
    <!--  -----------------------------------------------------------------------------------
                                            MODAL GRAFICOS 
          ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal
        ref="modal-grafico-vendedores"
        id="modal-grafico-vendedores"
        :lazy="true"
        centered
        :no-enforce-focus="true"
        hide-header
        hide-footer
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        size="lg"
        @shown="onModalGraficosVendedoresShown"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #4299e1 0%, #2b6cb0 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-bar-chart text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Desempenho por Vendedor</h5>
                <small class="text-white opacity-75">Análise de vendas distribuídas por colaborador</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fecharModalGraficosVendedores()">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="bg-light rounded border shadow-xs p-3 mb-2" style="height: 380px;">
                <grafico-barra-vendedores-grande
                    ref="graficoVendedoresGrande"
                    :key="graficos.vendedoresModal.key"
                    :data="graficos.vendedoresModal.datasets"
                    :labels="graficos.vendedoresModal.labels"
                    :height="360"
                />
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top text-right">
            <b-button variant="soft-danger" pill class="px-5 font-weight-bold shadow-sm" @click="fecharModalGraficosVendedores()">
                FECHAR GRÁFICO
            </b-button>
        </div>
      </b-modal>


    </div>
    <!--  -----------------------------------------------------------------------------------
                                            MODAL GRAFICOS  MOVIMENTO
          ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal
        ref="modal-grafico-movimento"
        id="modal-grafico-movimento"
        :lazy="true"
        centered
        :no-enforce-focus="true"
        hide-header
        hide-footer
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        size="lg"
        @shown="onModalGraficosMovimentoShown"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #48bb78 0%, #2f855a 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
                <i class="fa fa-line-chart text-white"></i>
            </div>
            <div>
                <h5 class="mb-0 font-weight-bold text-white">Evolução do Movimento</h5>
                <small class="text-white opacity-75">Análise temporal de vendas no período selecionado</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fecharModalGraficosMovimento()">
                <i class="fa fa-times fa-lg"></i>
            </b-button>
        </div>

        <div class="p-4 bg-white">
            <div class="bg-light rounded border shadow-xs p-3 mb-2" style="height: 380px;">
                <grafico-linha-vendas-grande
                  ref="graficoMovimentoGrande"
                  :points="graficos.vendasPointsPequeno"
                  :dt1="dt1" 
                  :dt2="dt2"
                  :height="360"
                />
            </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top text-right">
            <b-button variant="soft-danger" pill class="px-5 font-weight-bold shadow-sm" @click="fecharModalGraficosMovimento()">
                FECHAR GRÁFICO
            </b-button>
        </div>
      </b-modal>


    </div>

    <!-- Modal de Confirmação para Resultado Grande -->
    <ModalAlertaResultadoGrande
      ref="modalConfirmacao"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="modalConfirmacaoAberto = true"
      @hidden="modalConfirmacaoAberto = false"
    />

    <!-- -------------------------------------------------------------------------
                            MODAL OCORRÊNCIAS DA VENDA
    --------------------------------------------------------------------------- -->
    <div>
      <b-modal
        ref="modal-ocorrencias-venda"
        id="modal-ocorrencias-venda"
        hide-header
        hide-footer
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        size="lg"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark"
          style="background: linear-gradient(135deg, #17a2b8 0%, #0c5460 100%) !important;">
          <div class="header-icon-wrapper mr-3 bg-white-10">
            <i class="fa fa-comments text-white"></i>
          </div>
          <div>
            <h5 class="mb-0 font-weight-bold text-white">Ocorrências de Entrega</h5>
            <small class="text-white opacity-75">
              Pedido {{ entregaVenda.nVenda }} — {{ entregaVenda.nomeCliente }}
            </small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-ocorrencias-venda')">
            <i class="fa fa-times fa-lg"></i>
          </b-button>
        </div>

        <div class="p-4 bg-white" style="max-height: 60vh; overflow-y: auto;">
          <div v-if="entregaVenda.ocorrencias.carregando" class="text-center py-4">
            <b-spinner variant="info" label="Carregando..."></b-spinner>
            <p class="text-muted mt-2 mb-0">Carregando ocorrências...</p>
          </div>
          <div v-else-if="entregaVenda.ocorrencias.itens.length === 0" class="text-center py-4 text-muted">
            <i class="fa fa-inbox fa-2x mb-2"></i>
            <p class="mb-0">Nenhuma ocorrência registrada para este pedido.</p>
          </div>
          <div v-else>
            <div
              v-for="oc in entregaVenda.ocorrencias.itens"
              :key="oc.ID"
              class="mb-3 p-3 rounded border shadow-xs d-flex align-items-start"
            >
              <div class="mr-3 mt-1">
                <span class="badge badge-pill badge-info px-2 py-1" style="font-size: 0.7rem;">{{ oc.TIPO_OCORRENCIA }}</span>
              </div>
              <div class="flex-grow-1">
                <p class="mb-1 font-weight-bold text-dark">{{ oc.DESCRICAO }}</p>
                <small class="text-muted">
                  <i class="fa fa-clock-o mr-1"></i>{{ oc.DT_OCORRENCIA_FORMATADA || oc.DT_OCORRENCIA }}
                  <span v-if="oc.USUARIO" class="ml-2">
                    <i class="fa fa-user mr-1"></i>{{ oc.USUARIO }}
                  </span>
                </small>
              </div>
              <b-button
                variant="link"
                size="sm"
                class="text-danger p-0 ml-2"
                v-b-tooltip.hover title="Excluir ocorrência"
                @click="excluirOcorrenciaVenda(oc)"
              >
                <i class="fa fa-trash"></i>
              </b-button>
            </div>
          </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top text-right">
          <b-button variant="soft-danger" pill class="px-5 font-weight-bold shadow-sm" @click="$bvModal.hide('modal-ocorrencias-venda')">
            FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>

    <!-- -------------------------------------------------------------------------
                            MODAL DOCUMENTOS / CANHOTOS DA VENDA
    --------------------------------------------------------------------------- -->
    <div>
      <b-modal
        ref="modal-documentos-venda"
        id="modal-documentos-venda"
        hide-header
        hide-footer
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        size="lg"
      >
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark"
          style="background: linear-gradient(135deg, #fd7e14 0%, #6f3100 100%) !important;">
          <div class="header-icon-wrapper mr-3 bg-white-10">
            <i class="fa fa-paperclip text-white"></i>
          </div>
          <div>
            <h5 class="mb-0 font-weight-bold text-white">Canhotos e Documentos</h5>
            <small class="text-white opacity-75">
              Pedido {{ entregaVenda.nVenda }} — {{ entregaVenda.nomeCliente }}
            </small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-documentos-venda')">
            <i class="fa fa-times fa-lg"></i>
          </b-button>
        </div>

        <div class="p-4 bg-white" style="max-height: 60vh; overflow-y: auto;">
          <div v-if="entregaVenda.documentos.carregando" class="text-center py-4">
            <b-spinner variant="warning" label="Carregando..."></b-spinner>
            <p class="text-muted mt-2 mb-0">Carregando documentos...</p>
          </div>
          <div v-else-if="entregaVenda.documentos.itens.length === 0" class="text-center py-4 text-muted">
            <i class="fa fa-folder-open fa-2x mb-2"></i>
            <p class="mb-0">Nenhum documento enviado para este pedido.</p>
          </div>
          <div v-else>
            <div
              v-for="doc in entregaVenda.documentos.itens"
              :key="doc.ID"
              class="mb-3 p-3 rounded border shadow-xs d-flex align-items-center"
            >
              <i class="fa fa-file fa-lg mr-3 text-warning"></i>
              <div class="flex-grow-1">
                <p class="mb-0 font-weight-bold text-dark">{{ doc.NOME_ARQUIVO }}</p>
                <small class="text-muted">
                  {{ doc.TIPO_DOC }}
                  <span v-if="doc.DT_UPLOAD_FORMATADA || doc.DT_UPLOAD" class="ml-2">
                    <i class="fa fa-clock-o mr-1"></i>{{ doc.DT_UPLOAD_FORMATADA || doc.DT_UPLOAD }}
                  </span>
                  <span v-if="doc.USUARIO" class="ml-2">
                    <i class="fa fa-user mr-1"></i>{{ doc.USUARIO }}
                  </span>
                </small>
              </div>
              <b-button
                variant="link"
                size="sm"
                class="text-danger p-0 ml-2"
                v-b-tooltip.hover title="Excluir documento"
                @click="excluirDocumentoVenda(doc)"
              >
                <i class="fa fa-trash"></i>
              </b-button>
            </div>
          </div>
        </div>

        <div class="modal-footer-premium p-3 bg-light border-top text-right">
          <b-button variant="soft-danger" pill class="px-5 font-weight-bold shadow-sm" @click="$bvModal.hide('modal-documentos-venda')">
            FECHAR
          </b-button>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import moment from 'moment'
import Tools from '@/tools/tools.js'
import { Callout } from '../../../components/'
import GraficoBarraVendedoresPequeno from './GraficoBarraVendedoresPequeno.vue'
import GraficoBarraVendedoresGrande  from './GraficoBarraVendedoresGrande.vue'
import GraficoLinhaVendasPequeno from './GraficoLinhaVendasPequeno.vue'
import GraficoLinhaVendasGrande from './GraficoLinhaVendasGrande.vue'
import {Money} from 'v-money'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';
import { imprimirFaturaVenda } from './VendaFaturaHTML'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'

function formatarDataBrSemFuso(value) {
  if (!value) return null

  const texto = String(value).trim()
  const matchIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (matchIso) {
    const [, ano, mes, dia] = matchIso
    return `${dia}/${mes}/${ano}`
  }

  const dataUtc = moment.utc(texto, moment.ISO_8601, true)
  if (dataUtc.isValid()) return dataUtc.format('DD/MM/YYYY')

  const dataLocal = moment(texto)
  return dataLocal.isValid() ? dataLocal.format('DD/MM/YYYY') : null
}

export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    Callout,
    GraficoBarraVendedoresGrande,
    GraficoBarraVendedoresPequeno,
    GraficoLinhaVendasPequeno,
    GraficoLinhaVendasGrande,
    Money,
    SetFilter,
    ModalAlertaResultadoGrande,
    CecInputData
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    preferVh: 69,
    useExternalPaging: true,
    filters: [
      { key: 'N_VENDA', type: 'string', label: 'Pedido' },
      { key: 'NOME_CLIENTE', type: 'string', label: 'Cliente' },
      { key: 'SITUACAO', type: 'string', label: 'Situacao' ,
        labelMap: { 
                  '0':  'CANCELADO',
                  '1':  'FECHADO',
                  '2':  'LANÇANDO',
                  '3':  'AGUARD. ORDEM',
                  '4':  'ORDEM EXP',
                  '5':  'EMBARCANDO',
                  '6':  'CONFERIDO / PRONTO P/ VENDA',
                  '7':  'AGUARDANDO SEPARACAO',
                  '8':  'EM SEPARACAO'}
      }, 
      {
        key: 'DT_SAIDA',
        type: 'date',
        label: 'Data',
        toText: value => formatarDataBrSemFuso(value)
      },
      { key: 'NOME_VENDEDOR', type: 'string', label: 'Vendeddor' },
      { key: 'FORMA', type: 'string', label: 'Tipo' },
      { key: 'VL_TOTAL_NFE', type: 'currency', label: 'Total' },
    ]
  })],

  data () {
    return {
      graficos: {
        
        vendasPointsPequeno: [],
        vendasPointsGrande: [],
        vendasModal: {
          key: 0,                  // comece em 0 (não null)
          modalShow: false,        // controlado pelos eventos do modal
        },
        vendedores: {
          total: 0,
          labels: [],
          datasets: [{
            label: 'Valor R$:',
            backgroundColor: '#20a8d8',
            borderColor: [],
            data: []
          }]
        },
        vendedoresModal: {
          key: 0,                  // comece em 0 (não null)
          modalShow: false,        // controlado pelos eventos do modal
          total: 0,
          labels: [],
          datasets: [{
            label: 'Valor R$:',
            backgroundColor: '#20a8d8',
            borderColor: [],
            data: []
          }]
        }
      },
      receitaSemanaTotal: 25410.23,
      receitaSemanaTitulos: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'],
      receitaSemanaDados: [
        {
          label: 'Valor R$:',
          backgroundColor: '#20a8d8',
          borderColor: 'rgba(255,255,255,.55)',
          data: [200, 185, 590, 621, 250, 400, 95]
        }
      ],
      filtro: {
        avancado: false
      },
      restaurandoFiltrosTabela: true,
      formatoMoeda: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      contasOpcoes: [],
      empresas: {
        id: null,
        items : [],
        options: [
          { value: null, text: '' }
        ]
      },
      
      boleto:{
        empresaId: null,
        contaId: null,
        vendaId: null,
        SITUACAO: null,
        boletoId: null,
        documento: null,
        parcela: null,
        nomeCliente: null,
        clienteId: null,
        valorRecebimentos: 0.00,
        valorMulta: 0.00,
        valorDesconto: 0.00,
        valorDocumento: 0.00,
        valorRestante: 0.00,
        valorAberto: 0.00
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          titulo: null,
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        }
      },
      removerEtiquetas: {
        parametros: {
          currentPage: 1,
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          titulo: null,
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        },
        itensVenda: [],
        fieldsVenda: [ 
          {
            key: "COD_PRO",
            class:'text-right', 
            label: 'Produto'
          },
          {
            key: "DESCRICAO",
            label: 'Descrição'
          },
          {
            key: "QUANT",
            class:'text-right', 
            label: 'Quantidade',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : '0,000'
          },
          {
            key: "PECAS",
            class:'text-right', 
            label: 'Peças'
          }
        ],
        itensEtiquetas: [],
        fieldsEtiquetas: [
          {
            key: "SEQUENCIA_EMBARQUE",
            class:'text-right', 
            thStyle: { width: "5%" },
            label: 'Seq'
          },
          {
            key: "PRODUTO_ID",
            class:'text-right', 
            thStyle: { width: "5%" },
            label: 'id'
          },
          {
            key: "DESCRICAO",
            thStyle: { width: "25%" },
            label: 'Descrição'
          },
          {
            key: "CODIGO_INTERNO",
            class:'text-right', 
            thStyle: { width: "10%" },
            label: 'Cod. Interno'
          },
          {
            key: "CODIGO_BARRAS",
            class:'text-right', 
            thStyle: { width: "25%" },
            label: 'Cod. Barras'
          },
          {
            key: "CAIXA_DIGITO",
            class:'text-right', 
            thStyle: { width: "10%" },
            label: 'N. Caixa/Digito'
          },
          {
            key: "PECAS_CAIXA",
            class:'text-right', 
            thStyle: { width: "10%" },
            label: 'Peças'
          },
          {
            key: "PESO",
            class:'text-right', 
            thStyle: { width: "10%" },
            label: 'Peso Kg/Quant',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : '0,000'
          },
          {
            key: "actions" ,
            label: 'Ações',
            thStyle: { width: "5%" },
            thClass: "text-center align-middle p-0", // cabeçalho centralizado
            class: "text-center align-middle p-0"    // conteúdo centralizado na vertical e horizontal
          }

        ]

      },
      opTipoAtendimentoNfeOptions: [
        { value: null, text: 'Selecione...' },
        { value: '1', text: '1 - Operacao presencial' },
        { value: '2', text: '2 - Nao presencial, internet' },
        { value: '3', text: '3 - Nao presencial, teleatendimento' },
        { value: '9', text: '9 - Nao presencial, outros' },
        { value: '0', text: '0 - Nao se aplica' }
      ],
      dadosModalNotaFiscal: {
        venda: null,
        id: null,
        SITUACAO: null,
        documento: null,
        dataVenda : null,
        nomeCliente: null,
        nomeVendedor: null,
        empresaId: null,
        DT_SADIA_ENTRADA: null,
        TX_HORA_ENTRA_SAI: null,
        cliente: null,
        tipoMovimentacaoId: null,
        cfopId: null,
        consumidor: null,
        textoId: null,
        obsContribuinte: null,
        obsOutros: null,
        opTipoAtendimento: null,
        nfeId: null,
        preflight: null,
        diagnostico: null,
        cfopResolucao: null,
        validacaoIntegrador: null,
        total: 0.00,
        naturezaTexto: '',
        tipoMovimentacoes : {
          selected: null,
          options: null,
          items: []
        },
        cfops : {
          selected: null,
          options: null,
          items: []
        },
        empresas : {
          selected: null,
          options: null,
          items: []
        },
        textos : {
          selected: null,
          options: null,
          items: []
        },
        mensagem: {
          texto: null,
          tipo: null
        }

      },
      dadosModalInfo: {
        id: null,
        documento: null,
        dataVenda : null,
        nomeCliente: null,
        nomeVendedor: null,
        usuarioAlteracao: null,
        dataAlteracao: null,
        motivoAlteracao: null,
        usuarioCancelamento: null,
        dataCancelamento: null,
        motivoCancelamento: null,
        total: 0.00

      },
      tabelaItens: {
        fields: [
          {
            key: "CODIGO_NOME_PRODUTO",
            label: 'Produto'
          },
          {
            key: "QUANT",
            label: 'Quantidade',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: "PECAS",
            label: 'Peças'
          },
          {
            key: "TX_UNIDADE_COMERCIAL",
            label: 'UND'
          },
          {
            key: 'VL_UNT', 
            class:'text-right', 
            label: 'Valor (R$)', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          {
            key: 'COMISSAO', 
            class:'text-right', 
            label: 'Comissão %', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : '0.00%'
          },
          {
            key: 'VALOR_COMISSAO', 
            class:'text-right', 
            label: 'Valor Comissão', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 'R$ 0,00'
          },
          {
            key: 'VL_DESCONTO', 
            class:'text-right', 
            label: 'Desconto (R$)', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          {
            key: 'VL_TOTAL_BRUTO', 
            class:'text-right', 
            label: 'Total (R$)', 
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          }
        ],
        items: []
      },
      optionsSituacao: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'Cancelado' },
        { value: '1', text: 'Fechado' },
        { value: '2', text: 'Aberto' },
        { value: '6', text: 'Conferido / Pronto p/ Venda' }
      ],
      optionsFiltroFormaPagto: [
        { value: '', text: 'Todos' },
        { value: 'V', text: 'VISTA' },
        { value: 'P', text: 'PRAZO' }
      ],
      optionsFiltroBoleto: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'BN' },
        { value: '1', text: 'BP' },
        { value: '2', text: 'Emitido' }
      ],
      optionsFiltroNf: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'NFN' },
        { value: '1', text: 'NFP' },
        { value: '2', text: 'NFE' }
      ],
      optionsFiltroFinanceiro: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'ABR' },
        { value: '1', text: 'FIN' }
      ],
      optionsFiltroOrigem: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'PRE' },
        { value: '1', text: 'PED' },
        { value: '2', text: 'SER' }
      ],
      optionsFiltroAlterado: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'ORI' },
        { value: '1', text: 'ALT' }
      ],
      optionsFiltroEntrega: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'Pendente' },
        { value: '1', text: 'Entregue' }
      ],
      optionsConsumidor: [
        { value: '', text: '' },
        { value: '0', text: 'Não' },
        { value: '1', text: 'Sim' },
      ],
      status: '',
      isBusy: false,
      fields: [
        {
          key: "DETALHE",
          class:'align-middle text-center p-0',
          label: '',
          thStyle: { width: "2%" }
        },
        {
          key: "N_VENDA",
          label: 'Pedido', 
          thStyle: { width: "5%" },
          sortable: true 
        },
        {
          key: "NFE_RELACIONADA",
          label: 'NFe',
          thStyle: { width: "8%" },
          sortable: true
        },
        {
          key: "NOME_CLIENTE",
          label: 'Nome do Cliente',
          thStyle: { width: "20%" },
          sortable: true 
        },
        {
          key: "SITUACAO",
          label: 'Situação',
          thStyle: { width: "7%" },
          sortable: true 
        },
        {
          key: "OP_FORMA_PAGTO",
          label: 'Informações',
          thStyle: { width: "17%" },
          sortable: true 
        },
        {
          key: "DT_SAIDA",
          label: 'Data Venda', 
          thStyle: { width: "10%" },
          type:'date',
          sortable: true,
          formatter: (value, key, item) => 
            formatarDataBrSemFuso(value)
        },
        {
          key: "NOME_VENDEDOR",
          label: 'Vendedor', 
          thStyle: { width: "13%" },
          sortable: true 
        },
        {
          key: "FORMA",
          label: 'Forma', 
          thStyle: { width: "10%" },
          sortable: true 
        },
        {
          key: 'VL_TOTAL_NFE', 
          class:'text-right', 
          label: 'Total (R$)', 
          type:'currency',
          thStyle: { width: "7%" },
          sortable: true,
          formatter: (value, key, item) => 
            value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : null
        },
        {
          key: "actions" ,
          label: 'Ações',
          thStyle: { width: "5%" },
           class:'text-right align-middle p-0'
        }
      ],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      entregaVenda: {
        vendaId: null,
        nVenda: null,
        nomeCliente: null,
        embarqueId: null,
        ocorrencias: {
          carregando: false,
          itens: []
        },
        documentos: {
          carregando: false,
          itens: []
        }
      },
      columns: [
        {title: 'ID', dataKey: 'id'},
        {title: 'Name', dataKey: 'name'},
        {title: 'Country', dataKey: 'country'}
      ],
      rows: [
        {'id': 1, 'name': 'Shaw', 'country': 'Tanzania'},
        {'id': 2, 'name': 'Nelson', 'country': 'Kazakhstan'},
        {'id': 3, 'name': 'Garcia', 'country': 'Madagascar'}
      ]
    }

  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    nfeMotorNodeAtivo() {
      return true
    },
    preflightPendenciasNotaFiscal() {
      return this.dadosModalNotaFiscal.preflight?.pendencias || []
    },
    preflightTemErroNotaFiscal() {
      return this.preflightPendenciasNotaFiscal.some(item => item.nivel === 'ERRO')
    },
    cfopDiagnosticoNotaFiscal() {
      const resolucao = this.dadosModalNotaFiscal.cfopResolucao || this.dadosModalNotaFiscal.diagnostico?.cfop || null
      if (!resolucao) return null

      const id = resolucao.cfopId || resolucao.id || resolucao.cfop?.CONTADOR || this.dadosModalNotaFiscal.diagnostico?.cfop?.id
      const origem = String(resolucao.origem || '').trim()
      if (!id || !origem) return null

      const veioDaMatriz = origem === 'NFE_CFOP_REGRA'
      return {
        id,
        variant: veioDaMatriz ? 'info' : 'warning',
        mensagem: veioDaMatriz
          ? 'definido pela matriz fiscal NFE_CFOP_REGRA.'
          : 'definido pelo CFOP padrao do tipo de movimentacao.'
      }
    },
    vlTotalNfeRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_TOTAL_NFE) || 0), 0)
      return this.formatCurrency(auxValor)
    },
    valMotivoCancelamento() {
      return ((this.cancelamento.dados.motivo ) && (this.cancelamento.dados.motivo != '')) ? true : false 
    },
    valEmitirNotaFiscal() {
      return this.isVendaFechada(this.dadosModalNotaFiscal) &&
        this.valEmpresaId &&
        this.valTipoMovimentacaoId &&
        (this.nfeMotorNodeAtivo || this.valCfopId) &&
        (this.nfeMotorNodeAtivo || this.valConsumidor) &&
        this.valTipoAtendimentoNfe
    },
    valEmpresaId() {
      return this.dadosModalNotaFiscal.empresaId ? true : false
    },
    valTipoMovimentacaoId() {
      return this.dadosModalNotaFiscal.tipoMovimentacaoId ? true : false
    },
    valCfopId() {
      return this.dadosModalNotaFiscal.cfopId ? true : false
    },
    valConsumidor() {
      return this.dadosModalNotaFiscal.consumidor ? true : false
    },
    valTipoAtendimentoNfe() {
      if (!this.nfeMotorNodeAtivo) return true
      return ['0', '1', '2', '3', '9'].includes(String(this.dadosModalNotaFiscal.opTipoAtendimento || '').trim())
    },
    podeConfirmarGeracaoBoleto() {
      return this.isVendaFechada(this.boleto) && !!this.boleto.empresaId && !!this.boleto.contaId
    },
    
    user () {
      return '' // this.$store.state.dadosSessao.nome
    },
    currentPage: {
      get () {
        return this.$store.getters['venda/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("venda/SET_PAGINA_ATUAL", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['venda/PER_PAGE']
      },
      set (value) {
        this.$store.commit("venda/SET_PER_PAGE", value)
      }
    },
    dt1: {
      get () {
        return this.$store.getters['venda/DT1']
      }, 
      set (value) {
        this.$store.commit("venda/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['venda/DT2']
      }, 
      set (value) {
        this.$store.commit("venda/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['venda/ID']
      }, 
      set (value) {
        this.$store.commit("venda/SET_ID", value);
      }
    },
    pedido: {
      get () {
        return this.$store.getters['venda/PEDIDO']
      }, 
      set (value) {
        this.$store.commit("venda/SET_PEDIDO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['venda/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("venda/SET_CLIENTE_ID", value)
      }
    },
    tipoSituacao: {
      get () {
        return this.$store.getters['venda/TIPO_SITUACAO']
      }, 
      set (value) {
        this.$store.commit("venda/SET_TIPO_SITUACAO", value)
      }
    },
    nfeRelacionada: {
      get () {
        return this.$store.getters['venda/NFE_RELACIONADA']
      },
      set (value) {
        this.$store.commit('venda/SET_NFE_RELACIONADA', value)
      }
    },
    filtroFormaPagto: {
      get () {
        return this.$store.getters['venda/FILTRO_FORMA_PAGTO']
      },
      set (value) {
        this.$store.commit('venda/SET_FILTRO_FORMA_PAGTO', value)
      }
    },
    filtroBoleto: {
      get () {
        return this.$store.getters['venda/FILTRO_BOLETO']
      },
      set (value) {
        this.$store.commit('venda/SET_FILTRO_BOLETO', value)
      }
    },
    filtroNf: {
      get () {
        return this.$store.getters['venda/FILTRO_NF']
      },
      set (value) {
        this.$store.commit('venda/SET_FILTRO_NF', value)
      }
    },
    filtroFinanceiro: {
      get () {
        return this.$store.getters['venda/FILTRO_FINANCEIRO']
      },
      set (value) {
        this.$store.commit('venda/SET_FILTRO_FINANCEIRO', value)
      }
    },
    filtroOrigem: {
      get () {
        return this.$store.getters['venda/FILTRO_ORIGEM']
      },
      set (value) {
        this.$store.commit('venda/SET_FILTRO_ORIGEM', value)
      }
    },
    filtroAlterado: {
      get () {
        return this.$store.getters['venda/FILTRO_ALTERADO']
      },
      set (value) {
        this.$store.commit('venda/SET_FILTRO_ALTERADO', value)
      }
    },
    filtroEntrega: {
      get () {
        return this.$store.getters['venda/FILTRO_ENTREGA']
      },
      set (value) {
        this.$store.commit('venda/SET_FILTRO_ENTREGA', value)
      }
    },
    lista: {
      get () {
        return this.$store.getters['venda/LISTA']
      }, 
      set (value) {
        this.$store.commit("venda/SET_LISTA", value)
      }
    },
    parametrosExpedicao: {
      get () {
        return this.$store.getters['venda/PARAMETROS_EXPEDICAO']
      }
    }
  },
  methods: {
    clonarFiltrosTabela(filtros = this.filtros) {
      const clone = {}
      Object.keys(filtros || {}).forEach(key => {
        clone[key] = Array.isArray(filtros[key]) ? [...filtros[key]] : []
      })
      return clone
    },
    salvarFiltrosTabela() {
      if (this.restaurandoFiltrosTabela) return
      this.$store.commit('venda/SET_FILTROS_TABELA_LISTAGEM', this.clonarFiltrosTabela())
    },
    restaurarFiltrosTabela() {
      const filtrosSalvos = this.$store.getters['venda/FILTROS_TABELA_LISTAGEM']
      if (!filtrosSalvos || typeof filtrosSalvos !== 'object') {
        this.restaurandoFiltrosTabela = false
        return
      }

      this.restaurandoFiltrosTabela = true
      Object.keys(this.filtros || {}).forEach(key => {
        const valorSalvo = filtrosSalvos[key]
        if (Array.isArray(valorSalvo)) {
          this.$set(this.filtros, key, [...valorSalvo])
        }
      })
      this.restaurandoFiltrosTabela = false
    },
    normalizarStringFlag(valor) {
      return String(valor == null ? '' : valor).trim().toUpperCase()
    },
    preencherCamposInformacao(item) {
      if (!item) return item

      this.$set(item, 'NFE_RELACIONADA', item.NFE_RELACIONADA || (item.NOTA_FISCAL_ID ? String(item.NOTA_FISCAL_ID) : ''))
      this.$set(item, 'INFO_FORMA_PAGTO_LABEL', this.traduzirOP_FORMA_PAGTO(item.OP_FORMA_PAGTO) || 'SEM FORMA')
      this.$set(item, 'INFO_BOLETO_LABEL', this.traduzirBoleto(item.OP_STATUS_BOLETO_EMITIDO) || 'SEM BOLETO')
      this.$set(item, 'INFO_NF_LABEL', this.traduzirNF(item) || 'SEM NF')
      this.$set(item, 'INFO_FINANCEIRO_LABEL', this.traduzirFinanceiro(item.TEM_FINANCEIRO) || 'SEM FIN')
      this.$set(item, 'INFO_ORIGEM_LABEL', this.traduzirOrigem(item.OP_PEDIDO) || 'SEM ORIGEM')
      this.$set(item, 'INFO_ALTERADO_LABEL', this.traduzirAlterado(item.OP_ALTERADO) || 'SEM ALT')
      this.$set(item, 'INFO_ENTREGA_LABEL', this.normalizarStringFlag(item.OP_RETORNO_ENTREGA) === '1' ? 'ENTREGUE' : 'PENDENTE')
      return item
    },
    prepararListaParaExibicao(lista = this.lista) {
      ;(lista || []).forEach(item => this.preencherCamposInformacao(item))
      return lista
    },
    ajustarPaginaParaRegistroSelecionado() {
      const selecionadoId = this.$store.getters['venda/REGISTRO_SELECIONADO_ID']
      if (!selecionadoId) return

      const index = (this.itensFiltrados || []).findIndex(item => item.SEQUENCIA === selecionadoId)
      if (index >= 0) {
        this.currentPage = Math.floor(index / this.perPage) + 1
      }
    },
    focarFiltroPrincipal() {
      if (this.$refs.dt1) {
        if (typeof this.$refs.dt1.focus === 'function') this.$refs.dt1.focus()
        else if (this.$refs.dt1.$el) this.$refs.dt1.$el.focus()
      }
    },
    rolarParaRegistroSelecionado() {
      const linhaSelecionada = this.$el && this.$el.querySelector ? this.$el.querySelector('.cec-row-selected') : null
      if (!linhaSelecionada) return false

      linhaSelecionada.scrollIntoView({ block: 'center', behavior: 'auto' })
      return true
    },
    restaurarContextoVisual() {
      this.$nextTick(() => {
        if (!this.rolarParaRegistroSelecionado()) {
          this.focarFiltroPrincipal()
        }
      })
    },
    aplicarContextoAposCarregamento() {
      this.prepararListaParaExibicao()
      this.atualizarGraficoVendedores(this.lista || [])
      this.ajustarPaginaParaRegistroSelecionado()
      this.restaurarContextoVisual()
    },
    exportarHtml () {
      printHtmlReport({
        rows: this.itensFiltrados,                 // seu array de dados
        columns: this.fields,
        systemName: 'CECWeb',
        reportTitle: 'Listagem de PreFaturas',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: `Período: ${this.dt1} a ${this.dt2}`,
        pageSize: 'A4',
        landscape: true,                    // vira “deitado” se quiser
        footerTotals: [
          // soma só a coluna VL_TOTAL_NFE (usa key da coluna)
          { key:'VL_TOTAL_NFE', formatter: v => v ? v.toLocaleString('pt-BR',{style:'currency',currency:'BRL'}) : 'R$ 0,00' }
        ],
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'prefaturas.xls',
        sumKey: 'VL_TOTAL_NFE'              // mesma key da sua coluna de Débito (soma no rodapé)
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'prefaturas.csv',
      });
    },
    clicarMenuLinha(item) {
        this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
   },
    isVendaFechada(item) {
      return String((item && item.SITUACAO) || '').trim() === '1'
    },
    podeGerarBoleto(item) {
      const statusBoleto = String(item && item.OP_STATUS_BOLETO_EMITIDO != null ? item.OP_STATUS_BOLETO_EMITIDO : '').trim()
      return this.isVendaFechada(item) && ['0', '1'].includes(statusBoleto)
    },
    podeVisualizarBoleto(item) {
      const statusBoleto = String(item && item.OP_STATUS_BOLETO_EMITIDO != null ? item.OP_STATUS_BOLETO_EMITIDO : '').trim().toUpperCase()
      return this.isVendaFechada(item) && !['', '0', '1'].includes(statusBoleto)
    },
    statusNfeVenda(item) {
      return String(item && item.NFE_OP_STATUS != null ? item.NFE_OP_STATUS : '').trim()
    },
    nfeAutorizada(item) {
      return this.statusNfeVenda(item) === '2'
    },
    podeGerarNotaFiscal(item) {
      const statusNfe = this.statusNfeVenda(item)
      if (statusNfe) {
        return this.isVendaFechada(item) && statusNfe !== '2'
      }
      const statusNfeLegado = String(item && item.OP_STATUS_NOTA_FISCAL_EMITIDA != null ? item.OP_STATUS_NOTA_FISCAL_EMITIDA : '').trim()
      return this.isVendaFechada(item) && statusNfeLegado !== '2'
    },
    
    async abrirModalGerarBoleto(item) {
      if (!this.podeGerarBoleto(item)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Boleto permitido apenas para venda fechada.')
        return
      }

      this.boleto.vendaId    = item.SEQUENCIA
      this.boleto.documento     = item.SEQUENCIA
      this.boleto.clienteId     = item.COD_CLI
      this.boleto.empresaId     = 1
      this.boleto.SITUACAO      = item.SITUACAO
      this.boleto.nomeCliente   = item.NOME_CLIENTE
      this.boleto.contaId       = null
      this.boleto.valorRecebimentos = 0.00
      this.boleto.valorMulta    = 0.00
      this.boleto.valorDesconto = 0.00
      this.boleto.valorAberto   = item.VL_TOTAL_NFE
      this.boleto.valorDocumento  = item.VL_TOTAL_NFE
      this.boleto.valorRestante   = item.VL_TOTAL_NFE
      this.boleto.valorRestante   = (Number(item.VL_TOTAL_NFE) || 0) - (Number(this.boleto.valorRecebimentos) || 0)
      
      this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.carregarEmpresas()
          await this.carregarContas()
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Operação Indisponível', 'danger', err)
          return
        }

        this.$refs['modal-boleto-gerar'].show()
        
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

      
    },
    async gerarBoleto() {
      if (!this.isVendaFechada(this.boleto)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Boleto permitido apenas para venda fechada.')
        return
      }

      if (!this.boleto.contaId) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Selecione a conta bancária para emitir o boleto.')
        return
      }

      if (!this.boleto.empresaId) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Informe os dados Obrigatórios.')
        return
      }

      // Lógica para gerar boleto
      const bodyBoleto = {
        vendaId: this.boleto.vendaId,
        bancoContaId: this.boleto.contaId,
        empresaId: this.boleto.empresaId,
        valorRestante: this.boleto.valorRestante
      }


      try {
        this.$store.commit('controle/setAguardando', true)
        let resultado
        try {
          resultado = await this.$http.post('/api/protected/boleto/postByVenda', bodyBoleto)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
          console.error('Erro ao gerar boleto:', err)
          return
        }

        await this.$store.dispatch('venda/GERAR_LISTA')

        const boletoGerado = (resultado?.data) ?? null
        if (!boletoGerado || !boletoGerado.boletosIds || boletoGerado.boletosIds.length === 0) {
          Tools.exibirMensagem(this.$store, 'Boleto', 'warning', 'Não foi possível gerar o Boleto!')
          return
        }

        const bodyGerar = {
          contaId: this.boleto.contaId,
          boletoId: boletoGerado.boletosIds[0],
          boletoIds: boletoGerado.boletosIds
        }

        try {
          resultado = await this.$http.post('/api/protected/integrador/gerarBoleto', bodyGerar)
          const boletoPDF = (resultado?.data) ?? null
          if (!boletoPDF || !boletoPDF.sucesso || !boletoPDF.pdfBase64) {
            const erro = resultado?.erro || 'Não foi possível baixar o PDF do Boleto.'
            Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
            return
          }

          // Converte base64 para blob
          const byteCharacters = atob(boletoPDF.pdfBase64)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const blob = new Blob([byteArray], { type: 'application/pdf' })

          // Cria a URL e abre o PDF
          const url = window.URL.createObjectURL(blob)
          window.open(url)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
          console.error('Erro ao gerar boleto:', err)
        }

        this.$refs['modal-boleto-gerar'].hide()

      }  finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async visualizarBoleto(item) {
      if (!item?.SEQUENCIA) {
        return
      }

      this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', item.SEQUENCIA)

      try {
        this.$store.commit('controle/setAguardando', true)

        const areceberResponse = await this.$http.get(`/api/protected/areceber/getByVendaId/${item.SEQUENCIA}`)
        const titulos = Array.isArray(areceberResponse?.data) ? areceberResponse.data : []
        const titulosComBoleto = titulos.filter(titulo => Number(titulo.BOLETO_ID) > 0)
        const boletoIds = titulosComBoleto.map(titulo => Number(titulo.BOLETO_ID)).filter(id => id > 0)
        const contaId = titulosComBoleto.find(titulo => Number(titulo.CONTA_BOLETO_ID) > 0)?.CONTA_BOLETO_ID || null

        if (!boletoIds.length) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nao foi localizado um boleto emitido para esta prefatura.')
          return
        }

        const response = await this.$http.post('/api/protected/integrador/downloadPDFBoleto/', {
          boletoId: boletoIds[0],
          boletoIds,
          contaId
        })

        const resultado = response?.data ?? null
        if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
          const erro = resultado?.erro || 'Nao foi possivel baixar o PDF do boleto.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
          return
        }

        const byteCharacters = atob(resultado.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        window.open(window.URL.createObjectURL(blob))
      } catch (err) {
        console.error('Erro ao visualizar boleto da venda:', err)
        const erroMsg = err?.response?.data?.erro || err?.response?.data?.message || err?.message || 'Falha inesperada ao visualizar o boleto.'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', erroMsg)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00';
      // Ensure value is a number before calling toLocaleString
      const numericValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
      if (isNaN(numericValue)) return 'R$ 0,00';
      return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    formatDecimal(value, precision = 3) {
      if (value === null || value === undefined) return '0,000';
      // Ensure value is a number before calling toLocaleString
      const numericValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
      if (isNaN(numericValue)) return '0,000';
      return numericValue.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: precision });
    },
    async carregarEmpresas () {
      try {
        this.empresas.items = []
        this.empresas.options = []
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/empresa/getTodas'))
        

        const empresasAux = response?.data?? null
        if (!empresasAux) {
          throw new Error("Empresas " + err)
        }
        
        const empresasArray = [].concat(empresasAux || [])

        
        for (let emp of empresasArray) {
          this.empresas.options.push({value: emp.CODIGO, text: `${emp.APELIDO} - ${emp.IE} - ${emp.RAZAO}`})
        }

      } catch (err) {
        console.error('Erro em carregarEmpresas:', err)
      }
    },
    async carregarContas () {
      this.contasOpcoes = []
      this.boleto.contaId = null
      try {
      const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/conta/listarAtivasBoleto'))
      if (response && response.data) {
        for (let conta of response.data) {
        this.contasOpcoes.push({ value: conta.ID, text: conta.CODIGONOME })
        }
      }
      } catch (error) {
          console.error('Erro em carregarContas:', error)
      }
    },
    
    async toggleDetalhesVenda(row) {
      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", row.item.SEQUENCIA)

      if (!row.item.detalhes && !row.item.loading) {
        this.$set(row.item, 'loading', true)

        const detalhes = await this.buscarDetalhesVenda(row.item.SEQUENCIA)

        this.$set(row.item, 'detalhes', detalhes)
        this.$set(row.item, 'loading', false)
      }

      row.toggleDetails()
    },

    async onToggleDetails(row, expanded) {
      // Apenas necessário se quiser reagir diretamente ao evento
    },

    async buscarDetalhesVenda(id) {
      // Simula chamada backend

      const itensResult = await this.$http.get('/api/protected/venda/item/getListagemByVenda/'+id)
      return itensResult.data ?? null

    },
    
    async downloadPDFNfe (item) {
      try {
        this.$store.commit('controle/setAguardando', true)

        const body = {
          nfeId: item.NOTA_FISCAL_ID,
          empresaId: item.EMPRESA_NOTA_FISCAL_ID
        }

        const response = await this.$http.post(`/api/protected/notaFiscal/downloadPDF/`, body)

        const resultado = response.data

        if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
          const erro = resultado?.erro || 'Não foi possível baixar o PDF da Nota Fiscal.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
          return
        }

        // Converte base64 para blob
        const byteCharacters = atob(resultado.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })

        // Cria a URL e abre o PDF
        const url = window.URL.createObjectURL(blob)
        window.open(url)

        
        

      } catch (err) {
        console.error('Erro na download da nota:', err)

        const erroMsg = err.response?.data?.erro || 'Falha inesperada ao gerar a nota fiscal.'
        this.$root.$bvToast.toast(erroMsg, {
          title: 'Erro',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async emitirNotaFiscal () {
      this.dadosModalNotaFiscal.mensagem = { texto: null, tipo: null }
      this.dadosModalNotaFiscal.preflight = null
      this.dadosModalNotaFiscal.diagnostico = null
      this.dadosModalNotaFiscal.cfopResolucao = null
      this.dadosModalNotaFiscal.validacaoIntegrador = null
      this.dadosModalNotaFiscal.nfeId = null

      if (!this.isVendaFechada(this.dadosModalNotaFiscal)) {
        this.dadosModalNotaFiscal.mensagem = { texto: 'Nota fiscal permitida apenas para venda fechada.', tipo: 'warning' }
        return
      }

      if (!this.valEmitirNotaFiscal) {
        this.dadosModalNotaFiscal.mensagem = { texto: 'Preencha os campos obrigatórios', tipo: 'warning' }
        return
      }

      if (this.nfeMotorNodeAtivo) {
        return this.emitirNotaFiscalMotorNode()
      }

      return this.emitirNotaFiscalLegado()
    },
    montarPayloadNotaFiscalBase() {
      return {
        vendaId: this.dadosModalNotaFiscal.id,
        empresaId: this.dadosModalNotaFiscal.empresaId,
        DT_SADIA_ENTRADA: this.dadosModalNotaFiscal.DT_SADIA_ENTRADA,
        TX_HORA_ENTRA_SAI: this.dadosModalNotaFiscal.TX_HORA_ENTRA_SAI,
        textoContribuinte: this.dadosModalNotaFiscal.obsContribuinte,
        usuario: window.localStorage.getItem('login'),
        tela: 'V'
      }
    },
    montarPayloadNotaFiscalMotorNode() {
      return {
        ...this.montarPayloadNotaFiscalBase(),
        tipoMovimentacaoId: this.dadosModalNotaFiscal.tipoMovimentacaoId,
        opTipoAtendimento: this.dadosModalNotaFiscal.opTipoAtendimento,
        dataSaida: this.dadosModalNotaFiscal.DT_SADIA_ENTRADA,
        horaSaida: this.dadosModalNotaFiscal.TX_HORA_ENTRA_SAI
      }
    },
    async validarNotaFiscalMotorNode() {
      this.dadosModalNotaFiscal.mensagem = { texto: null, tipo: null }
      this.dadosModalNotaFiscal.preflight = null
      this.dadosModalNotaFiscal.diagnostico = null
      this.dadosModalNotaFiscal.cfopResolucao = null
      this.dadosModalNotaFiscal.validacaoIntegrador = null
      this.dadosModalNotaFiscal.nfeId = null

      if (!this.nfeMotorNodeAtivo) return

      if (!this.isVendaFechada(this.dadosModalNotaFiscal)) {
        this.dadosModalNotaFiscal.mensagem = { texto: 'Nota fiscal permitida apenas para venda fechada.', tipo: 'warning' }
        return
      }

      if (!this.valEmitirNotaFiscal) {
        this.dadosModalNotaFiscal.mensagem = { texto: 'Preencha os campos obrigatorios', tipo: 'warning' }
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        const response = await this.$http.post('/api/protected/nfeMotor/diagnosticarVenda', this.montarPayloadNotaFiscalMotorNode())
        const resultado = response.data || {}
        this.dadosModalNotaFiscal.preflight = resultado.preflight || null
        this.dadosModalNotaFiscal.diagnostico = resultado.diagnostico || null
        this.dadosModalNotaFiscal.cfopResolucao = resultado.cfopResolucao || null

        if (!resultado.sucesso) {
          this.dadosModalNotaFiscal.mensagem = { texto: resultado.erro || 'Nao foi possivel validar a NF-e.', tipo: 'danger' }
          return
        }

        if (resultado.preflight && resultado.preflight.ok === false) {
          this.dadosModalNotaFiscal.mensagem = {
            texto: 'Validacao fiscal encontrou pendencias. Corrija os dados antes de transmitir.',
            tipo: this.preflightTemErroNotaFiscal ? 'danger' : 'warning'
          }
          return
        }

        this.dadosModalNotaFiscal.mensagem = {
          texto: 'Validacao fiscal concluida sem erros. A NF-e ainda nao foi gravada.',
          tipo: 'success'
        }
      } catch (err) {
        console.error('Erro na validacao fiscal pelo motor Node:', err)
        this.dadosModalNotaFiscal.mensagem = { texto: this.extrairErroNotaFiscal(err), tipo: 'danger' }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async emitirNotaFiscalLegado() {
      try {
        this.$store.commit('controle/setAguardando', true)

        const response = await this.$http.post(`/api/protected/notaFiscal/gerarIntegrador/`, this.montarPayloadNotaFiscalBase())
        await this.finalizarEmissaoNotaFiscal(response.data)
      } catch (err) {
        console.error('Erro na geração da nota:', err)
        this.dadosModalNotaFiscal.mensagem = { texto: this.extrairErroNotaFiscal(err), tipo: 'danger' }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async emitirNotaFiscalMotorNode() {
      try {
        this.$store.commit('controle/setAguardando', true)

        const prepararResponse = await this.$http.post('/api/protected/nfeMotor/prepararVenda', this.montarPayloadNotaFiscalMotorNode())
        const preparacao = prepararResponse.data || {}
        this.dadosModalNotaFiscal.nfeId = preparacao.nfeId || null
        this.dadosModalNotaFiscal.preflight = preparacao.preflight || null
        this.dadosModalNotaFiscal.cfopResolucao = preparacao.cfopResolucao || null
        this.dadosModalNotaFiscal.validacaoIntegrador = null

        if (!preparacao.sucesso || !preparacao.nfeId) {
          this.dadosModalNotaFiscal.mensagem = { texto: preparacao.erro || 'Não foi possível preparar a NF-e.', tipo: 'danger' }
          return
        }

        if (preparacao.preflight && preparacao.preflight.ok === false) {
          this.dadosModalNotaFiscal.mensagem = {
            texto: `NF-e ${preparacao.nfeId} preparada com pendências fiscais. Corrija as pendências antes de transmitir.`,
            tipo: 'danger'
          }
          return
        }

        const validacaoIntegradorResponse = await this.$http.post('/api/protected/notaFiscal/validarIntegrador', {
          nfeId: preparacao.nfeId,
          usuario: window.localStorage.getItem('login'),
          tela: 'V'
        })
        const validacaoIntegrador = validacaoIntegradorResponse.data || {}
        this.dadosModalNotaFiscal.validacaoIntegrador = validacaoIntegrador

        if (!validacaoIntegrador.sucesso) {
          this.dadosModalNotaFiscal.mensagem = {
            texto: validacaoIntegrador.erro || 'NF-e preparada, mas reprovada na validacao tecnica do integrador.',
            tipo: 'danger'
          }
          return
        }

        const transmitirResponse = await this.$http.post('/api/protected/notaFiscal/processarIntegrador', {
          nfeId: preparacao.nfeId,
          usuario: window.localStorage.getItem('login'),
          tela: 'V'
        })

        await this.finalizarEmissaoNotaFiscal(transmitirResponse.data)
      } catch (err) {
        console.error('Erro na geração da nota pelo motor Node:', err)
        this.dadosModalNotaFiscal.mensagem = { texto: this.extrairErroNotaFiscal(err), tipo: 'danger' }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async finalizarEmissaoNotaFiscal(resultado) {
      if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
        const erro = resultado?.erro || 'Não foi possível gerar o PDF.'
        this.dadosModalNotaFiscal.mensagem = { texto: erro, tipo: 'danger' }
        return
      }

      const byteCharacters = atob(resultado.pdfBase64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      window.open(url)

      await this.pesquisar(false)
      this.$refs['modal-nota-fiscal'].hide()

      this.$root.$bvToast.toast(`Nota Fiscal gerada com sucesso!`, {
        title: 'Aviso',
        autoHideDelay: 2000,
        variant: 'success',
        appendToast: true
      })
    },
    extrairErroNotaFiscal(err) {
      return (typeof err?.response?.data === 'string' && err.response.data)
        || err?.response?.data?.erro
        || err?.response?.data?.message
        || err?.message
        || String(err)
    },
    async abrirModalNotaFiscal(item) {
      if (!this.podeGerarNotaFiscal(item)) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nota fiscal permitida apenas para venda fechada.')
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", item.ID)
        this.dadosModalNotaFiscal.cliente = null
        this.dadosModalNotaFiscal.obsContribuinte = null
        this.dadosModalNotaFiscal.preflight = null
        this.dadosModalNotaFiscal.diagnostico = null
        this.dadosModalNotaFiscal.cfopResolucao = null
        this.dadosModalNotaFiscal.validacaoIntegrador = null
        this.dadosModalNotaFiscal.nfeId = null
        this.dadosModalNotaFiscal.opTipoAtendimento = null
        try {
          await this.carregarTipoMovimentacoes()
        } catch(err) {
          console.log(err)
        }

        try {
          await this.carregarCFOP()
        } catch(err) {
          console.log(err)
        }
        try {
          await this.carregarEmpresas()
        } catch(err) {
          console.log(err)
        }
        try {
          await this.carregarTextos()
        } catch(err) {
          console.log(err)
        }

        try {
          await this.carregarCliente(item.COD_CLI)
        } catch(err) {
          console.log(err)
        }

        this.dadosModalNotaFiscal.obsOutros = null
        try {
          const boletoResult = await this.$http.get('/api/protected/areceber/getInfoBoletoByVendaId/'+item.SEQUENCIA)
          const boleto = boletoResult.data?.[0]
          if (boleto) {
            this.dadosModalNotaFiscal.obsOutros = ' BOLETO: ' + boleto.TITULO_NOSSONUMERO
          }
        } catch(err) {
          console.log(err)
        }

        const tipoMovimentacao = this.dadosModalNotaFiscal.tipoMovimentacoes.items.find(tipos =>
          tipos.ID === item.TIPO_MOVIMENTACAO_ID
        )
        this.dadosModalNotaFiscal.tipoMovimentacaoId = tipoMovimentacao.ID?? null
        this.dadosModalNotaFiscal.cfopId = tipoMovimentacao.CFOP_ID?? null
        this.dadosModalNotaFiscal.consumidor = this.dadosModalNotaFiscal.cliente.OP_CONSUMIDOR

        this.dadosModalNotaFiscal.naturezaTexto = tipoMovimentacao.DESCRICAO
        this.dadosModalNotaFiscal.obsContribuinte = this.montarObservacaoContribuinteNotaFiscal()

        this.tabelaItens.items = null
        this.dadosModalNotaFiscal.id = null
        this.dadosModalNotaFiscal.SITUACAO = null
        this.dadosModalNotaFiscal.documento = null
        this.dadosModalNotaFiscal.dataVenda = null
        this.dadosModalNotaFiscal.DT_SADIA_ENTRADA = moment().format('YYYY-MM-DD')
        this.dadosModalNotaFiscal.TX_HORA_ENTRA_SAI = moment().format('HH:mm:ss')
        this.dadosModalNotaFiscal.nomeCliente = null
        this.dadosModalNotaFiscal.nomeVendedor = null
        this.dadosModalNotaFiscal.total = null
        try {
      
          const response = await this.$http.get('/api/protected/venda/item/getListagemByVenda/'+item.SEQUENCIA)
          this.tabelaItens.items = response.data
      
          this.dadosModalNotaFiscal.id = item.SEQUENCIA
          this.dadosModalNotaFiscal.SITUACAO = item.SITUACAO
          this.dadosModalNotaFiscal.documento = item.N_VENDA
          this.dadosModalNotaFiscal.dataVenda = formatarDataBrSemFuso(item.DT_SAIDA) || ''
          this.dadosModalNotaFiscal.nomeCliente = item.NOME_CLIENTE
          this.dadosModalNotaFiscal.nomeVendedor = item.NOME_VENDEDOR
          this.dadosModalNotaFiscal.total = this.formatCurrency(item.VL_TOTAL_NFE)

          this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
          this.dadosModalNotaFiscal.mensagem = { texto: null, tipo: null }
          this.$refs['modal-nota-fiscal'].show()
        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponível' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    // -----------------------------------------------------------------------
    // Métodos de Entrega (Painel Motorista integrado)
    // -----------------------------------------------------------------------
    async confirmarEntregaVenda(item) {
      this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', item.SEQUENCIA)
      const resposta = await this.$bvModal.msgBoxConfirm(
        `Confirmar a entrega do Pedido ${item.N_VENDA} ao cliente ${item.NOME_CLIENTE}?`,
        {
          title: 'Confirmar Entrega?',
          size: 'md',
          buttonSize: 'lg',
          okVariant: 'success',
          okTitle: 'SIM, CONFIRMAR',
          cancelTitle: 'CANCELAR',
          centered: true
        }
      )
      if (!resposta) return
      try {
        this.$store.commit('controle/setAguardando', true)
        const isOrdemEntrega = !!item.ORDEM_ENTREGA_ID
        const body = isOrdemEntrega
          ? {
            ordemEntregaId: item.ORDEM_ENTREGA_ID,
            vendaId: item.SEQUENCIA,
            usuario: window.localStorage.getItem('login')
          }
          : {
            embarqueId: item.ORDEM_EXPEDICAO_ID || null,
            vendaId: item.SEQUENCIA,
            usuario: window.localStorage.getItem('login')
          }
        const endpoint = isOrdemEntrega
          ? '/api/protected/ordementrega/confirmarEntregaVenda'
          : '/api/protected/motorista/marcarEntregue'
        await this.$http.post(endpoint, body)
        // Atualiza o item na lista local sem recarregar tudo
        this.$set(item, 'OP_RETORNO_ENTREGA', '1')
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Entrega confirmada com sucesso!')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err || 'Erro ao confirmar entrega')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async abrirOcorrenciasVenda(item) {
      this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', item.SEQUENCIA)
      this.entregaVenda.vendaId = item.SEQUENCIA
      this.entregaVenda.nVenda = item.N_VENDA
      this.entregaVenda.nomeCliente = item.NOME_CLIENTE
      this.entregaVenda.ocorrencias.itens = []
      this.entregaVenda.ocorrencias.carregando = true
      this.$bvModal.show('modal-ocorrencias-venda')
      try {
        const response = await this.$http.get(`/api/protected/motorista/ocorrencias/${item.SEQUENCIA}`)
        this.entregaVenda.ocorrencias.itens = response.data || []
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Erro ao carregar ocorrências')
      } finally {
        this.entregaVenda.ocorrencias.carregando = false
      }
    },

    async abrirDocumentosVenda(item) {
      this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', item.SEQUENCIA)
      this.entregaVenda.vendaId = item.SEQUENCIA
      this.entregaVenda.nVenda = item.N_VENDA
      this.entregaVenda.nomeCliente = item.NOME_CLIENTE
      this.entregaVenda.documentos.itens = []
      this.entregaVenda.documentos.carregando = true
      this.$bvModal.show('modal-documentos-venda')
      try {
        const response = await this.$http.get(`/api/protected/motorista/documentos/${item.SEQUENCIA}`)
        this.entregaVenda.documentos.itens = response.data || []
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Erro ao carregar documentos')
      } finally {
        this.entregaVenda.documentos.carregando = false
      }
    },

    async excluirOcorrenciaVenda(ocorrencia) {
      const resposta = await this.$bvModal.msgBoxConfirm('Excluir esta ocorrência?', {
        title: 'Confirmar Exclusão',
        okVariant: 'danger',
        okTitle: 'EXCLUIR',
        cancelTitle: 'CANCELAR',
        centered: true
      })
      if (!resposta) return
      try {
        await this.$http.delete(`/api/protected/motorista/ocorrencia/${ocorrencia.ID}`)
        const idx = this.entregaVenda.ocorrencias.itens.findIndex(o => o.ID === ocorrencia.ID)
        if (idx !== -1) this.entregaVenda.ocorrencias.itens.splice(idx, 1)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Ocorrência excluída.')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err || 'Erro ao excluir ocorrência')
      }
    },

    async excluirDocumentoVenda(documento) {
      const resposta = await this.$bvModal.msgBoxConfirm('Excluir este documento?', {
        title: 'Confirmar Exclusão',
        okVariant: 'danger',
        okTitle: 'EXCLUIR',
        cancelTitle: 'CANCELAR',
        centered: true
      })
      if (!resposta) return
      try {
        await this.$http.delete(`/api/protected/motorista/documento/${documento.ID}`)
        const idx = this.entregaVenda.documentos.itens.findIndex(d => d.ID === documento.ID)
        if (idx !== -1) this.entregaVenda.documentos.itens.splice(idx, 1)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Documento excluído.')
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err || 'Erro ao excluir documento')
      }
    },

    async carregarTipoMovimentacoes() {
      try {
        const response = await this.$http.get(`/api/protected/tipoMovimentacao/listar`)
        const dados = response.data

        //Armazenar também os itens
        this.dadosModalNotaFiscal.tipoMovimentacoes.items = response.data

        //preencher o combo
        this.dadosModalNotaFiscal.tipoMovimentacoes.options = []
        if (Array.isArray(dados)) {
          for (const tipo of dados) {
            this.dadosModalNotaFiscal.tipoMovimentacoes.options.push({
              value: tipo.ID,
              text: tipo.ID + ' - ' + tipo.DESCRICAO
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em carregarTipoMovimentacoes:', err)
        return null
      }
    },
    async carregarCFOP() {
      try {
        const response = await this.$http.get(`/api/protected/cfop/listarTodos`)
        const dados = response.data

        //Armazenar também os itens
        this.dadosModalNotaFiscal.cfops.items = response.data

        //preencher o combo
        this.dadosModalNotaFiscal.cfops.options = []
        if (Array.isArray(dados)) {
          for (const tipo of dados) {
            this.dadosModalNotaFiscal.cfops.options.push({
              value: tipo.CONTADOR,
              text: tipo.CONTADOR + ' - ' + tipo.UTILIZACAO
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em carregarCFOP:', err)
        return null
      }
    },
    async carregarTextos() {
      try {
        const response = await this.$http.get(`/api/protected/parametro/getTextos`)
        const dados = response.data

        //Armazenar também os itens
        this.dadosModalNotaFiscal.textos.items = response.data

        //preencher o combo
        this.dadosModalNotaFiscal.textos.options = []
        if (Array.isArray(dados)) {
          for (const tipo of dados) {
            this.dadosModalNotaFiscal.textos.options.push({
              value: tipo.ID??'',
              text: tipo.ID ? tipo.ID + ' - ' + tipo.DESCRICAO : ''
            })
          }
        }

        return dados

      } catch (err) {
        console.error('Erro em carregarTextos:', err)
        return null
      }
    },
    async carregarCliente(clienteId) {
      try {
        const response = await this.$http.get(`/api/protected/cliente/getById/${clienteId}`)
        this.dadosModalNotaFiscal.cliente = response.data?.[0]
        return true
      } catch (err) {
        console.error('Erro em carregarTextos:', err)
        return false
      }
    },
    montarObservacaoContribuinteNotaFiscal() {
      const observacaoCliente = String(this.dadosModalNotaFiscal.cliente?.OB_OBSERVACOES_REPRESENTACAO || '').trim()
      return observacaoCliente || null
    },
    async cancelar() {
      if (!this.valMotivoCancelamento) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Motivo' )
        return
      }
      try {
        this.$store.commit('controle/setAguardando', true)

        try {
          await this.$http.get(`/api/protected/venda/permiteExcluir/${this.cancelamento.dados.id}`)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }

        let result = null
        try {
           result = await this.$http.get( `/api/protected/venda/getById/${this.cancelamento.dados.id}`)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        
        const dados = result.data?.[0]
        if (!dados) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponível no momento' )
          return
        }
          
        dados.TX_USUARIO_CANCELAMENTO = this.cancelamento.dados.usuario
        dados.MOT_CANC = this.cancelamento.dados.motivo
            
        const body = {
            venda: dados,
            origem: 'web'
          }
        try {
          await this.$http.post(`/api/protected/venda/delete`, body )
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }

        await this.$store.dispatch('venda/GERAR_LISTA')
        this.$refs['modal-cancelamento'].hide()
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Sucesso' )
        
      } finally {
       this.$store.commit('controle/setAguardando', false) 
      }
    },
    
    async showMsgDevolver(item) {
      this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID",item.SEQUENCIA)
      const resposta = await this.$bvModal.msgBoxConfirm(`Devolver para o terminal de Expedição o Pedido: ${item.SEQUENCIA} Do Cliente: ${item.NOME_CLIENTE} ?`, {
        title: 'Devolver?',
        size: 'lg',
        buttonSize: 'lg',
        okVariant: 'primary',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      
      if (resposta == false) {
        return
      }
      let body = {
        vendaId: item.SEQUENCIA,
        usuario: window.localStorage.getItem('login')
      }
      try {
        this.$store.commit('controle/setAguardando', true) 
        try {
          await this.$http.post( `/api/protected/vendapedido/devolverExpedicao`, body)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        await this.$store.dispatch('venda/GERAR_LISTA')
        Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Sucesso' )
        
      } finally {
        this.$store.commit('controle/setAguardando', false) 
      }
    },
    async abrirModalInfo(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.tabelaItens.items = null
        this.dadosModalInfo.id = null
        this.dadosModalInfo.documento = null
        this.dadosModalInfo.dataVenda = null
        this.dadosModalInfo.nomeCliente = null
        this.dadosModalInfo.nomeVendedor = null
        this.dadosModalInfo.total = null
        
        this.dadosModalInfo.usuarioAlteracao = null
        this.dadosModalInfo.dataAlteracao = null
        this.dadosModalInfo.motivoAlteracao = null
        this.dadosModalInfo.usuarioCancelamento = null
        this.dadosModalInfo.dataCancelamento = null
        this.dadosModalInfo.motivoCancelamento = null
        try {
      
          const response = await this.$http.get('/api/protected/venda/item/getListagemByVenda/'+item.SEQUENCIA)
      
          this.tabelaItens.items = response.data
          this.dadosModalInfo.id = item.SEQUENCIA
          this.dadosModalInfo.documento = item.N_VENDA
          this.dadosModalInfo.dataVenda = formatarDataBrSemFuso(item.DT_SAIDA) || ''
          this.dadosModalInfo.nomeCliente = item.NOME_CLIENTE
          this.dadosModalInfo.nomeVendedor = item.NOME_VENDEDOR
          this.dadosModalInfo.total = this.formatCurrency(item.VL_TOTAL_NFE)
          
          this.dadosModalInfo.usuarioAlteracao = item.TX_USUARIO_ALTERACAO
          this.dadosModalInfo.dataAlteracao = item.DT_ALTERACAO ? moment(String(item.DT_ALTERACAO)).format('DD/MM/YYYY') : ''
          this.dadosModalInfo.motivoAlteracao = item.OBS3
          this.dadosModalInfo.usuarioCancelamento = item.TX_USUARIO_CANCELAMENTO
          this.dadosModalInfo.dataCancelamento = item.DT_CANC ? moment(String(item.DT_CANC)).format('DD/MM/YYYY') : ''
          this.dadosModalInfo.motivoCancelamento = item.MOT_CANC

          this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
          this.$refs['modal-info'].show()
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação indisponível' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async removerEtiquetaExpedicao(item) {
      const resposta = await this.$bvModal.msgBoxConfirm(`Remover a etiqueta selecionada?`, {
        title: 'Remover Etiqueta?',
        size: 'sm',
        buttonSize: 'lg',
        okVariant: 'primary',
        okTitle: 'SIM',
        cancelTitle: 'NAO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true ,
        noCloseOnBackdrop: true
      })
      
      if (resposta == false) {
        return
      }


      try {
        this.$store.commit('controle/setAguardando', true)
        
        try {
          const removerPayLoad= {
              etiquetaMovimentoId: item.ETIQUETA_MOVIMENTO_ID,
              login: window.localStorage.getItem('login') 
          }
          const removerResult = await this.$http.post('/api/protected/estoqueetiqueta/removerEtiquetaVenda', removerPayLoad)
          const removido = (removerResult?.data) ?? []
          if (!removido || !removido.STATUS) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel remover a etiqueta' )
            return  
          }

          if (removido.STATUS === 0 ) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', removido.MSG )
            return
          }

          if (removido.STATUS === 1 ) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'success', removido.MSG )
          }

        } catch(err)  {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        } 
        
        try {
          const itensVendaResult = await this.$http.get(`/api/protected/vendapedido/item/getByVendaOrdemExpedicao/${this.removerEtiquetas.dados.id}`)
          this.removerEtiquetas.itensVenda = (itensVendaResult?.data) ?? null
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Operação Indisponível!', 'warning', ' Não foi possível verificar os itens da venda')
          return
        }

        try {
          const etiquetasResult = await this.$http.get(`/api/protected/estoqueetiqueta/getEtiquetasByVenda/${this.removerEtiquetas.dados.id}`)
          this.removerEtiquetas.itensEtiquetas = (etiquetasResult?.data) ?? null
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Operação Indisponível!', 'warning', ' Não foi possível verificar os itens da venda')
          return
        }

        await this.pesquisar(false)  // Mantém o registro selecionado

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async abrirModalRemoverEtiquetas(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          //await this.$http.get(`api/protected/venda/getPermiteAlterar/${item.SEQUENCIA}`)
        } catch(err)  {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        

        this.removerEtiquetas.dados.titulo = item.N_VENDA
        this.removerEtiquetas.dados.id = item.SEQUENCIA
        this.removerEtiquetas.dados.nomeCliente = item.NOME_CLIENTE
        this.removerEtiquetas.dados.documento = item.N_VENDA
        this.removerEtiquetas.dados.motivo = ''
        this.removerEtiquetas.dados.dataVencimento = formatarDataBrSemFuso(item.DT_SAIDA)
        this.removerEtiquetas.dados.valorDocumento = this.formatCurrency(item.VL_TOTAL_NFE)
        this.removerEtiquetas.dados.usuario = window.localStorage.getItem('login')

        this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)

        //venda Aberta
        if (this.lista.SITUACAO === '2') {
            this.removerEtiquetas.parametros.permissao = true
            this.removerEtiquetas.parametros.processando = false
            this.removerEtiquetas.parametros.busy = true
            this.$refs['modal-remover-etiquetas'].show()
            return
        }

        
        const permissaoPayLoad = {
          login: window.localStorage.getItem('login'),
          permissao: 'AcRemoverEtiquetaPelaPreFatura'
        }

        let permissaoResult = null
        try {
          this.$store.commit('controle/setAguardando', true)
          permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        } catch (err) {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
          return
        }

        const permissao = permissaoResult?.data?.permissao ?? null
      
        if (!permissao || permissao == false) {
          this.removerEtiquetas.parametros.permissao = false
          Tools.exibirMensagem(this.$store, 'Permissão', 'warning', 'Usuário não autorizado')
          return
        }

        try {
          const itensVendaResult = await this.$http.get(`/api/protected/vendapedido/item/getByVendaOrdemExpedicao/${item.SEQUENCIA}`)
          this.removerEtiquetas.itensVenda = (itensVendaResult?.data) ?? null
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Operação Indisponível!', 'warning', ' Não foi possível verificar os itens da venda')
          return
        }

        try {
          const etiquetasResult = await this.$http.get(`/api/protected/estoqueetiqueta/getEtiquetasByVenda/${item.SEQUENCIA}`)
          this.removerEtiquetas.itensEtiquetas = (etiquetasResult?.data) ?? null
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Operação Indisponível!', 'warning', ' Não foi possível verificar os itens da venda')
          return
        }

        

        this.removerEtiquetas.parametros.permissao = true
        this.removerEtiquetas.parametros.processando = false
        this.removerEtiquetas.parametros.busy = true
        this.$refs['modal-remover-etiquetas'].show()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    async abrirModalCancelamento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        try {
          await this.$http.get(`api/protected/venda/getPermiteAlterar/${item.SEQUENCIA}`)
        } catch(err)  {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        

        this.cancelamento.dados.titulo = item.N_VENDA
        this.cancelamento.dados.id = item.SEQUENCIA
        this.cancelamento.dados.nomeCliente = item.NOME_CLIENTE
        this.cancelamento.dados.documento = item.N_VENDA
        this.cancelamento.dados.motivo = ''
        this.cancelamento.dados.dataVencimento = formatarDataBrSemFuso(item.DT_SAIDA)
        this.cancelamento.dados.valorDocumento = this.formatCurrency(item.VL_TOTAL_NFE)
        this.cancelamento.dados.usuario = window.localStorage.getItem('login')

        this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)

        //venda Aberta
        if (this.lista.SITUACAO === '2') {
            this.cancelamento.parametros.permissao = true
            this.cancelamento.parametros.processando = false
            this.cancelamento.parametros.busy = true
            this.$refs['modal-cancelamento'].show()
            return
        }

        
        const permissaoPayLoad = {
          login: window.localStorage.getItem('login'),
          permissao: 'AcPropExcluirVendas'
        }

        let permissaoResult = null
        try {
          this.$store.commit('controle/setAguardando', true)
          permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        } catch (err) {
          this.$store.commit('controle/setAguardando', false)
          Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
          return
        }

        const permissao = permissaoResult?.data?.permissao ?? null
      
        if (!permissao || permissao == false) {
          this.cancelamento.parametros.permissao = false
          Tools.exibirMensagem(this.$store, 'Permissão', 'warning', 'Usuário não autorizado')
          return
        }

        this.cancelamento.parametros.permissao = true
        this.cancelamento.parametros.processando = false
        this.cancelamento.parametros.busy = true
        this.$refs['modal-cancelamento'].show()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    focusModalRemoverEtiquetas() {
      //this.$refs.motivoCancelamento.focus()
    },
    focusModalCancelamento() {
      this.$refs.motivoCancelamento.focus()
    },
    limpar() {
      this.$store.commit("venda/SET_LIMPAR", null)
      this.restaurandoFiltrosTabela = true
      this._initAllFilters('all')
      this.restaurandoFiltrosTabela = false
      this.filtro.avancado = false
      this.salvarFiltrosTabela()
    },
    clicarLinha(item) {
      this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['venda/REGISTRO_SELECIONADO_ID']
      if (item.SEQUENCIA === selId) return 'cec-row-selected'
      if (item.OP_RETORNO_ENTREGA === '1') return 'tr-entregue'
      return ''
    },
    traduzirBoleto(valor) {
      switch (valor) {
        case '0':
          return 'BN'
        case '1':
          return 'BP'
        default:
          return valor
      }
    },
    traduzirOP_FORMA_PAGTO(valor) {
      switch (valor) {
        case 'V':
          return 'VISTA'
        case 'P':
          return 'PRAZO'
        default:
          return ''
      }
    },
    colorirOP_FORMA_PAGTO(valor) {
      switch (valor) {
        case 'V':
          return 'primary'
        case 'P':
          return 'info'
        default:
          return ''
      }
    },
    colorirBoleto(valor) {
      switch (valor) {
        case '0':
          return 'secondary'
        case '1':
          return 'warning'
        default:
          return 'success'
      }
    },
    traduzirNF(valor) {
      const item = valor && typeof valor === 'object' ? valor : null
      const statusNfe = this.statusNfeVenda(item)
      if (statusNfe) {
        return 'NFE'
      }

      switch (String(item ? item.OP_STATUS_NOTA_FISCAL_EMITIDA : valor)) {
        case '0':
          return 'NFN'
        case '1':
          return 'NFP'
        case '2':
          return 'NFE'
        default:
          return ''
      }
    },
    colorirNF(valor) {
      const item = valor && typeof valor === 'object' ? valor : null
      const statusNfe = this.statusNfeVenda(item)
      if (statusNfe) {
        switch (statusNfe) {
          case '2':
            return 'success'
          case '3':
            return 'danger'
          case '5':
            return 'warning'
          case '7':
            return 'purple'
          default:
            return 'secondary'
        }
      }

      switch (String(item ? item.OP_STATUS_NOTA_FISCAL_EMITIDA : valor)) {
        case '0':
          return 'secondary'
        case '1':
          return 'warning'
        case '2':
          return 'success'
        default:
          return ''
      }
    },
    traduzirFinanceiro(valor) {
      switch (String(valor)) {
        case '0':
          return 'ABR'
        case '1':
          return 'FIN'
        default:
          return ''
      }
    },
    colorirFinanceiro(valor) {
      switch (String(valor)) {
        case '0':
          return 'warning'
        case '1':
          return 'success'
        default:
          return ''
      }
    },
    traduzirAlterado(valor) {
      switch (valor) {
        case '0':
          return 'ORI'
        case '1':
          return 'ALT'
        default:
          return ''
      }
    },
    colorirAlterado(valor) {
      switch (String(valor)) {
        case '0':
          return 'success'
        case '1':
          return 'warning'
        default:
          return ''
      }
    },
    traduzirOrigem(valor) {
      switch (valor) {
        case '0':
          return 'PRE'
        case '1':
          return 'PED'
        case '2':
          return 'SER'  
        default:
          return ''
      }
    },
    colorirOrigem(valor) {
      switch (valor) {
        case '0':
          return 'secondary'
        case '1':
          return 'info'
        case '2':
          return 'warning'  
        default:
          return ''
      }
    },
    colorirFormaPagto(valor) {
      return ''
    },
    traduzirFormaPagto(valor) {
      if (valor === 'V') return 'A VISTA'
      else if (valor === 'P') return 'A PRAZO'
      else ''
    },
    getStatusOrdemEntrega(item) {
      return String((item && item.ORDEM_ENTREGA_STATUS) || '').trim()
    },
    usaFluxoConferencia() {
      return String((this.parametrosExpedicao && this.parametrosExpedicao.OP_EXPEDICAO_DIRETA) || '0').trim() === '2'
    },
    isEntregaConfirmada(item) {
      return String((item && item.OP_RETORNO_ENTREGA) || '0').trim() === '1'
    },
    podeConfirmarEntrega(item) {
      if (!item || this.isEntregaConfirmada(item)) return false
      const situacao = String(item.SITUACAO || '').trim()
      if (['4', '5', '6'].includes(situacao)) return true
      return situacao === '1' && !!item.ORDEM_ENTREGA_ID
    },
    colorirStatus(valor, item = null) {
      if (valor == '0') return 'danger'
      else if (valor == '1') {
        if (!this.usaFluxoConferencia()) return 'success'
        if (item && this.isEntregaConfirmada(item)) return 'success'
        if (!item || !item.ORDEM_ENTREGA_ID) return 'success'
        const statusOrdem = this.getStatusOrdemEntrega(item)
        if (statusOrdem === '1') return 'primary'
        if (['2', '3', '4'].includes(statusOrdem)) return 'info'
        return 'primary'
      }
      else if (valor == '2') return 'warning'
      else if (valor == '3') return 'info'
      else if (valor == '4') return 'secondary'
      else if (valor == '5') return 'indigo'
      else if (valor == '6') return 'primary'
      else return 'info'
      
    },
    traduzirSituacao(registro) {
      const item = registro && typeof registro === 'object' ? registro : null
      const valor = item ? item.SITUACAO : registro
      if (valor === '0') return 'CANCELADO'
      else if (valor === '1') {
        if (!this.usaFluxoConferencia()) return 'FECHADO'
        if (item && this.isEntregaConfirmada(item)) return 'ENTREGUE'
        if (!item || !item.ORDEM_ENTREGA_ID) return 'FECHADO / AGUARD. CARGA'
        const statusOrdem = this.getStatusOrdemEntrega(item)
        if (statusOrdem === '1') return 'EM EMBARQUE'
        if (['2', '3', '4'].includes(statusOrdem)) return 'EMBARCADO'
        return 'EM EMBARQUE'
      }
      else if (valor === '2') return 'LANÇANDO'
      else if (valor === '3') return 'AGUARD. ORDEM'
      else if (valor === '4') return 'ORDEM EXP'
      else if (valor === '5') return 'EMBARCANDO'
      else if (valor === '6') return item && String(item.OP_CONFERENCIA_VENDA || '0').trim() === '1' ? 'CONFERIDO / PRONTO P/ VENDA' : 'EMBARCADO'
      else return ''
    },
    details (item) {
      alert(JSON.stringify(item.item.SEQUENCIA))
    },
    async edit (item) {
      
      /*
      this.$store.commit('controle/setAguardando', true)
      try {
        this.registroSelecionadoId = item[0].SEQUENCIA
        await this.$http.get(`/api/protected/venda/getPermiteAlterar/${item[0].SEQUENCIA}`)
      } catch(err) {
        this.$store.commit('controle/setAguardando', false)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        return
      }
        */

      this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
      this.$router.push(`/movimentos/vendas/edit/${item.SEQUENCIA}`)
    },
    novo () {
      this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", null)
      this.$router.push(`/movimentos/vendas/add`)
    },
    onModalGraficosVendedoresShown () {
      // re-render garantido
      this.$nextTick(() => {
        const cmp = this.$refs.graficoVendedoresGrande
        if (!cmp) return
        if (cmp._chart && cmp._chart.destroy) cmp._chart.destroy()
        // chama o método do próprio componente que estende Bar
        if (typeof cmp.montarGrafico === 'function') cmp.montarGrafico()
      })
    },

    async abrirModalGraficosVendedores () {
      // (opcional) mude a key para forçar remontagem tbm
      this.graficos.vendedoresModal.key++
      this.$refs['modal-grafico-vendedores'].show()
    },

    async fecharModalGraficosVendedores () {
      this.graficos.vendedoresModal.modalShow = false
      this.$refs['modal-grafico-vendedores'].hide()
    },
    onModalGraficosMovimentoShown () {
      // re-render garantido
      this.$nextTick(() => {
        const cmp = this.$refs.graficoMovimentoGrande
        if (!cmp) return
        if (cmp._chart && cmp._chart.destroy) cmp._chart.destroy()
        // chama o método do próprio componente que estende Bar
        if (typeof cmp.montarGrafico === 'function') cmp.montarGrafico()
      })
    },

    async abrirModalGraficosMovimento () {
      // (opcional) mude a key para forçar remontagem tbm
      this.graficos.vendasModal.key++
      this.$refs['modal-grafico-movimento'].show()
    },

    async fecharModalGraficosMovimento () {
      this.graficos.vendasModal.modalShow = false
      this.$refs['modal-grafico-movimento'].hide()
    },
    colorFromString (str) {
      let hash = 0
      for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash)
      const hue = Math.abs(hash) % 360
      return `hsl(${hue}, 65%, 55%)`
    },
    makeColors (labels) { return labels.map(l => this.colorFromString(l || '—')) },

    // === ATUALIZA OS DOIS GRÁFICOS (tela e modal) ===
    atualizarGraficoVendedores (lista) {
      const mapa = (Array.isArray(lista) ? lista : []).reduce((acc, row) => {
        const vendedor = (row.NOME_VENDEDOR || '— Sem vendedor —').trim()
        const valor = Number(row.VL_TOTAL_NFE || 0)
        acc[vendedor] = (acc[vendedor] || 0) + valor
        return acc
      }, {})

      const entries = Object.entries(mapa).sort((a,b) => b[1]-a[1]).slice(0, 12)
      const labels  = entries.map(([nome]) => nome)
      const valores = entries.map(([, total]) => Number(total.toFixed(2)))
      const cores   = this.makeColors(labels)

      const totalStr = this.formatCurrency(valores.reduce((s,n)=>s+n,0))

      const dataset = {
        label: 'Vendas (R$)',
        data: [...valores],
        backgroundColor: [...cores],
        borderColor: cores.map(c => c.replace('55%', '40%')),
        borderWidth: 1
      }

      // gráfico compacto (recria objeto — ok)
      this.graficos.vendedores = {
        total: totalStr,
        labels: [...labels],
        datasets: [{ ...dataset }]
      }

      this.graficos.vendedoresModal = {
        total: totalStr,
        labels: [...labels],
        datasets: [{ ...dataset }]
      }

      const porDia = new Map()
      for (const row of lista) {
        const dia = String(row.DT_SAIDA || row.DT_VENDA).slice(0,10) // 'YYYY-MM-DD'
        porDia.set(dia, (porDia.get(dia)||0) + Number(row.VL_TOTAL_NFE||0))
      }
      this.graficos.vendasPointsPequeno = Array.from(porDia.entries())
        .map(([data, valor]) => ({ data, valor }))
        .sort((a,b)=> a.data.localeCompare(b.data))
    },

    async pesquisar (limparSelecao = true) {
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      // Guarda a página atual ANTES de qualquer operação
      const paginaAtual = this.$store.getters['venda/PAGINA_ATUAL']
      
      // Se for uma nova pesquisa iniciada pelo usuário, limpa seleção e volta para página 1
      if (limparSelecao) {
        this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', null)
        this.$store.commit('venda/SET_PAGINA_ATUAL', 1)
      }
      
      this.$store.commit('controle/setAguardando', true)
      
      try {
        const result = await this.$store.dispatch('venda/GERAR_LISTA')

        // Verifica se precisa de confirmação
        if (result && result.needsConfirmation) {
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmacao.show()
          return
        }

        const lista = this.$store.state.venda.lista || []
        this.prepararListaParaExibicao(lista)
        this.atualizarGraficoVendedores(lista)

        // Se estava preservando (não limpou), restaura a página que estava antes
        if (!limparSelecao) {
          this.$store.commit('venda/SET_PAGINA_ATUAL', paginaAtual)
          // Força atualização do componente de paginação
        }

        this.ajustarPaginaParaRegistroSelecionado()
        await this.$nextTick()
        this.restaurarContextoVisual()
        this.status = true
      } catch (err) {
        console.error('Erro ao pesquisar vendas:', err)
        this.status = false
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async confirmarCarregarResultadoGrande() {
      this.$store.commit('controle/setAguardando', true)
      try {
        await this.$store.dispatch('venda/GERAR_LISTA', { skipConfirmation: true })
        
        const lista = this.$store.state.venda.lista || []
        this.prepararListaParaExibicao(lista)
        this.atualizarGraficoVendedores(lista)
        this.ajustarPaginaParaRegistroSelecionado()
        await this.$nextTick()
        this.restaurarContextoVisual()
        
        this.status = true
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      } catch (err) {
        console.error('Erro ao confirmar carregamento:', err)
        this.status = false
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
    },
    async imprimirPesagemExpedicao (id) {
      try {
        this.$store.commit('controle/setAguardando', true)

        try {
          this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", id)
          const relPayLoad = {
            id: id,
            login: window.localStorage.getItem('login')
          }
          const response =   await this.$http.post(`/api/protected/relatorios/relVendaPedidoPesagemExpedicao`, relPayLoad, { responseType: 'arraybuffer' })
          
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', 'relVenda.pdf') 
          link.download = 'relVenda.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Relatório de Vendas'
            }, 2000);
          }

          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório Gerado com Sucesso!!!' )
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    /*
    async imprimirJasper (id) {
      try {
        this.$store.commit('controle/setAguardando', true)

        try {
          this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", id)
          const relPayLoad = {
            id: id,
            login: window.localStorage.getItem('login')
            
          }
          const response =   await this.$http.post(`/api/protected/relatorios/relvenda`, relPayLoad, { responseType: 'arraybuffer' })
          
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          
          link.href = url
          link.setAttribute('download', 'relVenda.pdf') 
          link.download = 'relVenda.pdf'
          const janela = window.open(link)
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Relatório de Vendas'
            }, 2000);
          }

          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Relatório Gerado com Sucesso!!!' )
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!' )
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    */
   async imprimir (id) {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', id)
        await imprimirFaturaVenda(id, this.$http)
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Relatório Indisponível!!!')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.$refs.btAdicionar.click()
      } 
      
    }
  },
  async created () {
    try {
      await this.$store.dispatch('venda/CARREGAR_PARAMETROS_EXPEDICAO')
    } catch (err) {
      console.error('Erro ao carregar parametros de expedicao:', err)
    }

    const listagem = this.$store.getters['venda/LISTA']
    const registroSelecionadoId = this.$store.getters['venda/REGISTRO_SELECIONADO_ID']
    this.filtro.avancado = this.$store.getters['venda/FILTRO_AVANCADO']
    
    // Se há um registro selecionado, significa que está voltando do cadastro
    // A lista já foi atualizada no VendaCadastro, apenas fecha o loading
    if (registroSelecionadoId) {
      // Fecha o loading que foi aberto no VendaCadastro
      this.$store.commit('controle/setAguardando', false)
      
      // Atualiza o gráfico com a lista já carregada
      const lista = this.$store.state.venda.lista || []
      this.prepararListaParaExibicao(lista)
      this.atualizarGraficoVendedores(lista)
      this.ajustarPaginaParaRegistroSelecionado()
    } 
    // Se não há lista, faz a primeira pesquisa (limpando seleção)
    else if (!listagem.length) {
      await this.pesquisar(true)  // true = limpar seleção
    }
  },
  async mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown);
    }, 200)

    this.$nextTick(() => {
      this.restaurarFiltrosTabela()
      this.aplicarContextoAposCarregamento()
    })
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // Garantir foco no dt1 ao exibir a página
      vm.$nextTick(() => {
        vm.restaurarContextoVisual()
      })
    })
  },
  beforeDestroy() {
    // Remove o evento de keydown ao destruir o componente
    document.removeEventListener("keydown", this.handleKeydown);
  },
  watch: {
    currentPage: {
      handler() {
        // Sincroniza com AppFooterTools quando currentPage mudar
        if (this._syncTools) {
          this.$nextTick(() => {
            this._syncTools()
          })
        }
      }
    },
    lista: {
      handler(novaLista) {
        this.prepararListaParaExibicao(novaLista || [])
      }
    },
    filtros: {
      deep: true,
      handler() {
        this.salvarFiltrosTabela()
      }
    },
    'filtro.avancado': function (val) {
      this.$store.commit('venda/SET_FILTRO_AVANCADO', val)
    },
    'dadosModalNotaFiscal.tipoMovimentacaoId': async function (val) {
      if (!val) return

      const tipoMov = this.dadosModalNotaFiscal.tipoMovimentacoes.items.find(item =>
        item.ID === val
      )
      if (!tipoMov) return
      
      this.dadosModalNotaFiscal.cfopId = tipoMov.CFOP_ID
      this.dadosModalNotaFiscal.textoId = tipoMov.TEXTO_NFE_ID
      this.dadosModalNotaFiscal.naturezaTexto = tipoMov.DESCRICAO

    }
  }
}
</script> 
<style >

/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky 
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}
*/
/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6  !important;
  color: #000000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6  !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #c2cfd6  !important;
}


/* Layout do bloco Callout */
.callout { padding: .05rem .5rem; }
.callout-row {
  display: flex;
  align-items: center;
  gap: .5rem;
}

/* Caixa do gráfico com tamanho fixo */
.cec-chart-box {
  width: 120px;      /* ajuste se quiser maior/menor */
  height: 32px;      /* combina com :height do componente */
  display: flex;
  align-items: center;
}

/* Faz o canvas preencher a caixa */
.cec-chart-box canvas {
  width: 100% !important;
  height: 100% !important;
}

/* Regras para evitar problemas de posicionamento nos gráficos */
.callout .cec-chart-wrapper { position: static; left: auto; top: auto; float: none; width: auto; }
.cec-chart-wrapper canvas { width: auto !important; }

/* premium styles */
.modal-header-premium {
  border-bottom: none;
  position: relative;
}

.header-icon-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 1.35rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.1);
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

/* Table Enhancements */
.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 10px 8px !important;
  color: #4a5568;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.bg-soft-warning { background-color: rgba(255, 193, 7, 0.12) !important; }
.bg-soft-success { background-color: rgba(40, 167, 69, 0.12) !important; }
.bg-soft-danger { background-color: rgba(220, 53, 69, 0.12) !important; }

.modal-footer-premium {
  background-color: #f8f9fa;
  border-top: 1px solid #edf2f7;
}

.list-header-premium {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 0.5rem 1rem;
  margin-bottom: 0.75rem;
  border-radius: 1rem;
}

.card-filter-premium {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background: #fdfdfd;
}

.btn-icon-only {
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

/* Redução de altura dos registros da tabela */
#table-transition-example tbody td {
  padding-top: 0.18rem !important;
  padding-bottom: 0.18rem !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
  vertical-align: middle;
  line-height: 1.25;
}

#table-transition-example thead th {
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
}

/* Redução de tamanho dos botões dentro da tabela */
#table-transition-example .btn-icon-only {
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
}

#table-transition-example .btn-icon-only i {
  font-size: 0.85rem;
}

/* Ajustes dos badges para manter compactos */
#table-transition-example .badge {
  padding: 0.35em 0.65em !important;
  line-height: 1.2;
}

/* Redução do espaçamento dos badges quando em grupo */
#table-transition-example .d-flex.flex-wrap.gap-1 {
  gap: 0.25rem !important;
}

/* Compactar texto do cliente */
#table-transition-example .font-weight-bold.text-dark {
  line-height: 1.2;
  margin-bottom: 0.1rem;
}

#table-transition-example small.text-muted {
  line-height: 1.2;
}

/* Painel de Filtro Compacto */
.compact-filter .form-control,
.compact-filter .custom-select {
  height: 38px !important;
  font-size: 0.85rem !important;
}

.compact-filter label {
  font-size: 0.75rem !important;
  margin-bottom: 0.25rem !important;
  color: #6c757d;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Responsividade do Header Premium */
@media (max-width: 991px) {
  .search-pill-responsive {
    flex-wrap: wrap;
    border-radius: 1rem !important;
    padding: 0.5rem !important;
  }
  
  .date-inputs-responsive {
    flex-wrap: wrap;
    border-left: none !important;
    padding-left: 0 !important;
    width: 100%;
    justify-content: center;
    margin-bottom: 0.5rem;
  }
  
  .btn-filtrar-responsive {
    width: 100%;
    margin-top: 0.25rem;
  }
}

@media (max-width: 767px) {
  .list-header-premium {
    gap: 0.5rem !important;
    padding-bottom: 1rem !important;
  }
  
  .list-header-premium .py-2 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.25rem !important;
  }
  
  .search-pill-responsive {
    width: 100%;
    margin-right: 0 !important;
    border-radius: 1.5rem !important;
  }
  
  .btn-adicionar-responsive {
    width: 100%;
    margin-top: 0.5rem;
  }
}

@media (max-width: 575px) {
  .date-inputs-responsive .mx-1 {
    width: 130px !important;
    margin: 0.25rem !important;
  }
  
  .btn-filtrar-responsive .fa-search {
    margin-right: 0 !important;
  }

  .header-icon-wrapper {
    width: 38px;
    height: 38px;
    font-size: 1.2rem;
  }
  
  .list-header-premium h4 {
    font-size: 1.15rem;
  }
}
/* Linha entregue - verde suave */
.table.b-table tbody tr.tr-entregue,
.table.b-table tbody tr.tr-entregue > td {
  background-color: #d4edda !important;
}
.table.b-table tbody tr.tr-entregue:hover > td {
  background-color: #c3e6cb !important;
}
/* Colunas sticky das linhas entregues */
.table.b-table tbody tr.tr-entregue td.b-table-sticky-column {
  background-color: #d4edda !important;
}
</style>





// WEBPACK FOOTER //
// src/views/movimentos/vendas/VendaListagem.vue